export const globalConst = {
  Ciudades: [
    {
        "idCiudad": "05002",
        "nombre": "ABEJORRAL - ANTIOQUIA",
        "ciuu": "05002",
        "departamento": ""
    },
    {
        "idCiudad": "54003",
        "nombre": "ABREGO - N. DE SANTANDER",
        "ciuu": "54003",
        "departamento": ""
    },
    {
        "idCiudad": "05004",
        "nombre": "ABRIAQUI - ANTIOQUIA",
        "ciuu": "05004",
        "departamento": ""
    },
    {
        "idCiudad": "50006",
        "nombre": "ACACIAS - META",
        "ciuu": "50006",
        "departamento": ""
    },
    {
        "idCiudad": "27006",
        "nombre": "ACANDI - CHOCO",
        "ciuu": "27006",
        "departamento": ""
    },
    {
        "idCiudad": "41006",
        "nombre": "ACEVEDO - HUILA",
        "ciuu": "41006",
        "departamento": ""
    },
    {
        "idCiudad": "13006",
        "nombre": "ACHI - BOLIVAR",
        "ciuu": "13006",
        "departamento": ""
    },
    {
        "idCiudad": "41013",
        "nombre": "AGRADO - HUILA",
        "ciuu": "41013",
        "departamento": ""
    },
    {
        "idCiudad": "25001",
        "nombre": "AGUA DE DIOS - CUNDINAMARCA",
        "ciuu": "25001",
        "departamento": ""
    },
    {
        "idCiudad": "20011",
        "nombre": "AGUACHICA - CESAR",
        "ciuu": "20011",
        "departamento": ""
    },
    {
        "idCiudad": "68013",
        "nombre": "AGUADA - SANTANDER",
        "ciuu": "68013",
        "departamento": ""
    },
    {
        "idCiudad": "17013",
        "nombre": "AGUADAS - CALDAS",
        "ciuu": "17013",
        "departamento": ""
    },
    {
        "idCiudad": "85010",
        "nombre": "AGUAZUL - CASANARE",
        "ciuu": "85010",
        "departamento": ""
    },
    {
        "idCiudad": "20013",
        "nombre": "AGUSTIN CODAZZI - CESAR",
        "ciuu": "20013",
        "departamento": ""
    },
    {
        "idCiudad": "41016",
        "nombre": "AIPE - HUILA",
        "ciuu": "41016",
        "departamento": ""
    },
    {
        "idCiudad": "25019",
        "nombre": "ALBAN - CUNDINAMARCA",
        "ciuu": "25019",
        "departamento": ""
    },
    {
        "idCiudad": "52019",
        "nombre": "ALBAN - NARIÑO",
        "ciuu": "52019",
        "departamento": ""
    },
    {
        "idCiudad": "18029",
        "nombre": "ALBANIA - CAQUETA",
        "ciuu": "18029",
        "departamento": ""
    },
    {
        "idCiudad": "44035",
        "nombre": "ALBANIA - LA GUAJIRA",
        "ciuu": "44035",
        "departamento": ""
    },
    {
        "idCiudad": "68020",
        "nombre": "ALBANIA - SANTANDER",
        "ciuu": "68020",
        "departamento": ""
    },
    {
        "idCiudad": "76020",
        "nombre": "ALCALA - VALLE DEL CAUCA",
        "ciuu": "76020",
        "departamento": ""
    },
    {
        "idCiudad": "52022",
        "nombre": "ALDANA - NARIÑO",
        "ciuu": "52022",
        "departamento": ""
    },
    {
        "idCiudad": "05021",
        "nombre": "ALEJANDRIA - ANTIOQUIA",
        "ciuu": "05021",
        "departamento": ""
    },
    {
        "idCiudad": "47030",
        "nombre": "ALGARROBO - MAGDALENA",
        "ciuu": "47030",
        "departamento": ""
    },
    {
        "idCiudad": "41020",
        "nombre": "ALGECIRAS - HUILA",
        "ciuu": "41020",
        "departamento": ""
    },
    {
        "idCiudad": "19022",
        "nombre": "ALMAGUER - CAUCA",
        "ciuu": "19022",
        "departamento": ""
    },
    {
        "idCiudad": "15022",
        "nombre": "ALMEIDA - BOYACA",
        "ciuu": "15022",
        "departamento": ""
    },
    {
        "idCiudad": "73024",
        "nombre": "ALPUJARRA - TOLIMA",
        "ciuu": "73024",
        "departamento": ""
    },
    {
        "idCiudad": "41026",
        "nombre": "ALTAMIRA - HUILA",
        "ciuu": "41026",
        "departamento": ""
    },
    {
        "idCiudad": "27025",
        "nombre": "ALTO BAUDO - CHOCO",
        "ciuu": "27025",
        "departamento": ""
    },
    {
        "idCiudad": "13030",
        "nombre": "ALTOS DEL ROSARIO - BOLIVAR",
        "ciuu": "13030",
        "departamento": ""
    },
    {
        "idCiudad": "73026",
        "nombre": "ALVARADO - TOLIMA",
        "ciuu": "73026",
        "departamento": ""
    },
    {
        "idCiudad": "05030",
        "nombre": "AMAGA - ANTIOQUIA",
        "ciuu": "05030",
        "departamento": ""
    },
    {
        "idCiudad": "05031",
        "nombre": "AMALFI - ANTIOQUIA",
        "ciuu": "05031",
        "departamento": ""
    },
    {
        "idCiudad": "73030",
        "nombre": "AMBALEMA - TOLIMA",
        "ciuu": "73030",
        "departamento": ""
    },
    {
        "idCiudad": "25035",
        "nombre": "ANAPOIMA - CUNDINAMARCA",
        "ciuu": "25035",
        "departamento": ""
    },
    {
        "idCiudad": "52036",
        "nombre": "ANCUYA - NARIÑO",
        "ciuu": "52036",
        "departamento": ""
    },
    {
        "idCiudad": "76036",
        "nombre": "ANDALUCIA - VALLE DEL CAUCA",
        "ciuu": "76036",
        "departamento": ""
    },
    {
        "idCiudad": "05034",
        "nombre": "ANDES - ANTIOQUIA",
        "ciuu": "05034",
        "departamento": ""
    },
    {
        "idCiudad": "05036",
        "nombre": "ANGELOPOLIS - ANTIOQUIA",
        "ciuu": "05036",
        "departamento": ""
    },
    {
        "idCiudad": "05038",
        "nombre": "ANGOSTURA - ANTIOQUIA",
        "ciuu": "05038",
        "departamento": ""
    },
    {
        "idCiudad": "25040",
        "nombre": "ANOLAIMA - CUNDINAMARCA",
        "ciuu": "25040",
        "departamento": ""
    },
    {
        "idCiudad": "05040",
        "nombre": "ANORI - ANTIOQUIA",
        "ciuu": "05040",
        "departamento": ""
    },
    {
        "idCiudad": "17042",
        "nombre": "ANSERMA - CALDAS",
        "ciuu": "17042",
        "departamento": ""
    },
    {
        "idCiudad": "76041",
        "nombre": "ANSERMANUEVO - VALLE DEL CAUCA",
        "ciuu": "76041",
        "departamento": ""
    },
    {
        "idCiudad": "05044",
        "nombre": "ANZA - ANTIOQUIA",
        "ciuu": "05044",
        "departamento": ""
    },
    {
        "idCiudad": "73043",
        "nombre": "ANZOATEGUI - TOLIMA",
        "ciuu": "73043",
        "departamento": ""
    },
    {
        "idCiudad": "05045",
        "nombre": "APARTADO - ANTIOQUIA",
        "ciuu": "05045",
        "departamento": ""
    },
    {
        "idCiudad": "66045",
        "nombre": "APIA - RISARALDA",
        "ciuu": "66045",
        "departamento": ""
    },
    {
        "idCiudad": "25599",
        "nombre": "APULO - CUNDINAMARCA",
        "ciuu": "25599",
        "departamento": ""
    },
    {
        "idCiudad": "15047",
        "nombre": "AQUITANIA - BOYACA",
        "ciuu": "15047",
        "departamento": ""
    },
    {
        "idCiudad": "47053",
        "nombre": "ARACATACA - MAGDALENA",
        "ciuu": "47053",
        "departamento": ""
    },
    {
        "idCiudad": "17050",
        "nombre": "ARANZAZU - CALDAS",
        "ciuu": "17050",
        "departamento": ""
    },
    {
        "idCiudad": "68051",
        "nombre": "ARATOCA - SANTANDER",
        "ciuu": "68051",
        "departamento": ""
    },
    {
        "idCiudad": "81001",
        "nombre": "ARAUCA - ARAUCA",
        "ciuu": "81001",
        "departamento": ""
    },
    {
        "idCiudad": "81065",
        "nombre": "ARAUQUITA - ARAUCA",
        "ciuu": "81065",
        "departamento": ""
    },
    {
        "idCiudad": "25053",
        "nombre": "ARBELAEZ - CUNDINAMARCA",
        "ciuu": "25053",
        "departamento": ""
    },
    {
        "idCiudad": "52051",
        "nombre": "ARBOLEDA - NARIÑO",
        "ciuu": "52051",
        "departamento": ""
    },
    {
        "idCiudad": "54051",
        "nombre": "ARBOLEDAS - N. DE SANTANDER",
        "ciuu": "54051",
        "departamento": ""
    },
    {
        "idCiudad": "05051",
        "nombre": "ARBOLETES - ANTIOQUIA",
        "ciuu": "05051",
        "departamento": ""
    },
    {
        "idCiudad": "15051",
        "nombre": "ARCABUCO - BOYACA",
        "ciuu": "15051",
        "departamento": ""
    },
    {
        "idCiudad": "13042",
        "nombre": "ARENAL - BOLIVAR",
        "ciuu": "13042",
        "departamento": ""
    },
    {
        "idCiudad": "05055",
        "nombre": "ARGELIA - ANTIOQUIA",
        "ciuu": "05055",
        "departamento": ""
    },
    {
        "idCiudad": "19050",
        "nombre": "ARGELIA - CAUCA",
        "ciuu": "19050",
        "departamento": ""
    },
    {
        "idCiudad": "76054",
        "nombre": "ARGELIA - VALLE DEL CAUCA",
        "ciuu": "76054",
        "departamento": ""
    },
    {
        "idCiudad": "47058",
        "nombre": "ARIGUANI - MAGDALENA",
        "ciuu": "47058",
        "departamento": ""
    },
    {
        "idCiudad": "13052",
        "nombre": "ARJONA - BOLIVAR",
        "ciuu": "13052",
        "departamento": ""
    },
    {
        "idCiudad": "05059",
        "nombre": "ARMENIA - ANTIOQUIA",
        "ciuu": "05059",
        "departamento": ""
    },
    {
        "idCiudad": "63001",
        "nombre": "ARMENIA - QUINDIO",
        "ciuu": "63001",
        "departamento": ""
    },
    {
        "idCiudad": "73055",
        "nombre": "ARMERO - TOLIMA",
        "ciuu": "73055",
        "departamento": ""
    },
    {
        "idCiudad": "13062",
        "nombre": "ARROYOHONDO - BOLIVAR",
        "ciuu": "13062",
        "departamento": ""
    },
    {
        "idCiudad": "20032",
        "nombre": "ASTREA - CESAR",
        "ciuu": "20032",
        "departamento": ""
    },
    {
        "idCiudad": "73067",
        "nombre": "ATACO - TOLIMA",
        "ciuu": "73067",
        "departamento": ""
    },
    {
        "idCiudad": "27050",
        "nombre": "ATRATO - CHOCO",
        "ciuu": "27050",
        "departamento": ""
    },
    {
        "idCiudad": "23068",
        "nombre": "AYAPEL - CORDOBA",
        "ciuu": "23068",
        "departamento": ""
    },
    {
        "idCiudad": "27073",
        "nombre": "BAGADO - CHOCO",
        "ciuu": "27073",
        "departamento": ""
    },
    {
        "idCiudad": "27075",
        "nombre": "BAHIA SOLANO - CHOCO",
        "ciuu": "27075",
        "departamento": ""
    },
    {
        "idCiudad": "27077",
        "nombre": "BAJO BAUDO - CHOCO",
        "ciuu": "27077",
        "departamento": ""
    },
    {
        "idCiudad": "19075",
        "nombre": "BALBOA - CAUCA",
        "ciuu": "19075",
        "departamento": ""
    },
    {
        "idCiudad": "66075",
        "nombre": "BALBOA - RISARALDA",
        "ciuu": "66075",
        "departamento": ""
    },
    {
        "idCiudad": "08078",
        "nombre": "BARANOA - ATLANTICO",
        "ciuu": "08078",
        "departamento": ""
    },
    {
        "idCiudad": "41078",
        "nombre": "BARAYA - HUILA",
        "ciuu": "41078",
        "departamento": ""
    },
    {
        "idCiudad": "52079",
        "nombre": "BARBACOAS - NARIÑO",
        "ciuu": "52079",
        "departamento": ""
    },
    {
        "idCiudad": "05079",
        "nombre": "BARBOSA - ANTIOQUIA",
        "ciuu": "05079",
        "departamento": ""
    },
    {
        "idCiudad": "68077",
        "nombre": "BARBOSA - SANTANDER",
        "ciuu": "68077",
        "departamento": ""
    },
    {
        "idCiudad": "68079",
        "nombre": "BARICHARA - SANTANDER",
        "ciuu": "68079",
        "departamento": ""
    },
    {
        "idCiudad": "50110",
        "nombre": "BARRANCA DE UPIA - META",
        "ciuu": "50110",
        "departamento": ""
    },
    {
        "idCiudad": "68081",
        "nombre": "BARRANCABERMEJA - SANTANDER",
        "ciuu": "68081",
        "departamento": ""
    },
    {
        "idCiudad": "44078",
        "nombre": "BARRANCAS - LA GUAJIRA",
        "ciuu": "44078",
        "departamento": ""
    },
    {
        "idCiudad": "13074",
        "nombre": "BARRANCO DE LOBA - BOLIVAR",
        "ciuu": "13074",
        "departamento": ""
    },
    {
        "idCiudad": "94343",
        "nombre": "BARRANCO MINAS - GUAINIA",
        "ciuu": "94343",
        "departamento": ""
    },
    {
        "idCiudad": "08001",
        "nombre": "BARRANQUILLA - ATLANTICO",
        "ciuu": "08001",
        "departamento": ""
    },
    {
        "idCiudad": "20045",
        "nombre": "BECERRIL - CESAR",
        "ciuu": "20045",
        "departamento": ""
    },
    {
        "idCiudad": "17088",
        "nombre": "BELALCAZAR - CALDAS",
        "ciuu": "17088",
        "departamento": ""
    },
    {
        "idCiudad": "15087",
        "nombre": "BELEN - BOYACA",
        "ciuu": "15087",
        "departamento": ""
    },
    {
        "idCiudad": "52083",
        "nombre": "BELEN - NARIÑO",
        "ciuu": "52083",
        "departamento": ""
    },
    {
        "idCiudad": "18094",
        "nombre": "BELEN DE LOS ANDAQUIES - CAQUE",
        "ciuu": "18094",
        "departamento": ""
    },
    {
        "idCiudad": "66088",
        "nombre": "BELEN DE UMBRIA - RISARALDA",
        "ciuu": "66088",
        "departamento": ""
    },
    {
        "idCiudad": "05088",
        "nombre": "BELLO - ANTIOQUIA",
        "ciuu": "05088",
        "departamento": ""
    },
    {
        "idCiudad": "05086",
        "nombre": "BELMIRA - ANTIOQUIA",
        "ciuu": "05086",
        "departamento": ""
    },
    {
        "idCiudad": "25086",
        "nombre": "BELTRAN - CUNDINAMARCA",
        "ciuu": "25086",
        "departamento": ""
    },
    {
        "idCiudad": "15090",
        "nombre": "BERBEO - BOYACA",
        "ciuu": "15090",
        "departamento": ""
    },
    {
        "idCiudad": "05091",
        "nombre": "BETANIA - ANTIOQUIA",
        "ciuu": "05091",
        "departamento": ""
    },
    {
        "idCiudad": "15092",
        "nombre": "BETEITIVA - BOYACA",
        "ciuu": "15092",
        "departamento": ""
    },
    {
        "idCiudad": "05093",
        "nombre": "BETULIA - ANTIOQUIA",
        "ciuu": "05093",
        "departamento": ""
    },
    {
        "idCiudad": "68092",
        "nombre": "BETULIA - SANTANDER",
        "ciuu": "68092",
        "departamento": ""
    },
    {
        "idCiudad": "25095",
        "nombre": "BITUIMA - CUNDINAMARCA",
        "ciuu": "25095",
        "departamento": ""
    },
    {
        "idCiudad": "15097",
        "nombre": "BOAVITA - BOYACA",
        "ciuu": "15097",
        "departamento": ""
    },
    {
        "idCiudad": "54099",
        "nombre": "BOCHALEMA - N. DE SANTANDER",
        "ciuu": "54099",
        "departamento": ""
    },
    {
        "idCiudad": "11001",
        "nombre": "BOGOTA D.C.",
        "ciuu": "11001",
        "departamento": ""
    },
    {
        "idCiudad": "25099",
        "nombre": "BOJACA - CUNDINAMARCA",
        "ciuu": "25099",
        "departamento": ""
    },
    {
        "idCiudad": "27099",
        "nombre": "BOJAYA - CHOCO",
        "ciuu": "27099",
        "departamento": ""
    },
    {
        "idCiudad": "19100",
        "nombre": "BOLIVAR - CAUCA",
        "ciuu": "19100",
        "departamento": ""
    },
    {
        "idCiudad": "68101",
        "nombre": "BOLIVAR - SANTANDER",
        "ciuu": "68101",
        "departamento": ""
    },
    {
        "idCiudad": "76100",
        "nombre": "BOLIVAR - VALLE DEL CAUCA",
        "ciuu": "76100",
        "departamento": ""
    },
    {
        "idCiudad": "20060",
        "nombre": "BOSCONIA - CESAR",
        "ciuu": "20060",
        "departamento": ""
    },
    {
        "idCiudad": "15104",
        "nombre": "BOYACA - BOYACA",
        "ciuu": "15104",
        "departamento": ""
    },
    {
        "idCiudad": "05107",
        "nombre": "BRICEÑO - ANTIOQUIA",
        "ciuu": "05107",
        "departamento": ""
    },
    {
        "idCiudad": "15106",
        "nombre": "BRICEÑO - BOYACA",
        "ciuu": "15106",
        "departamento": ""
    },
    {
        "idCiudad": "68001",
        "nombre": "BUCARAMANGA - SANTANDER",
        "ciuu": "68001",
        "departamento": ""
    },
    {
        "idCiudad": "54109",
        "nombre": "BUCARASICA - N. DE SANTANDER",
        "ciuu": "54109",
        "departamento": ""
    },
    {
        "idCiudad": "76109",
        "nombre": "BUENAVENTURA - VALLE DEL CAUCA",
        "ciuu": "76109",
        "departamento": ""
    },
    {
        "idCiudad": "15109",
        "nombre": "BUENAVISTA - BOYACA",
        "ciuu": "15109",
        "departamento": ""
    },
    {
        "idCiudad": "23079",
        "nombre": "BUENAVISTA - CORDOBA",
        "ciuu": "23079",
        "departamento": ""
    },
    {
        "idCiudad": "63111",
        "nombre": "BUENAVISTA - QUINDIO",
        "ciuu": "63111",
        "departamento": ""
    },
    {
        "idCiudad": "70110",
        "nombre": "BUENAVISTA - SUCRE",
        "ciuu": "70110",
        "departamento": ""
    },
    {
        "idCiudad": "19110",
        "nombre": "BUENOS AIRES - CAUCA",
        "ciuu": "19110",
        "departamento": ""
    },
    {
        "idCiudad": "52110",
        "nombre": "BUESACO - NARIÑO",
        "ciuu": "52110",
        "departamento": ""
    },
    {
        "idCiudad": "76113",
        "nombre": "BUGALAGRANDE - VALLE DEL CAUCA",
        "ciuu": "76113",
        "departamento": ""
    },
    {
        "idCiudad": "05113",
        "nombre": "BURITICA - ANTIOQUIA",
        "ciuu": "05113",
        "departamento": ""
    },
    {
        "idCiudad": "15114",
        "nombre": "BUSBANZA - BOYACA",
        "ciuu": "15114",
        "departamento": ""
    },
    {
        "idCiudad": "25120",
        "nombre": "CABRERA - CUNDINAMARCA",
        "ciuu": "25120",
        "departamento": ""
    },
    {
        "idCiudad": "68121",
        "nombre": "CABRERA - SANTANDER",
        "ciuu": "68121",
        "departamento": ""
    },
    {
        "idCiudad": "50124",
        "nombre": "CABUYARO - META",
        "ciuu": "50124",
        "departamento": ""
    },
    {
        "idCiudad": "94886",
        "nombre": "CACAHUAL - GUAINIA",
        "ciuu": "94886",
        "departamento": ""
    },
    {
        "idCiudad": "05120",
        "nombre": "CACERES - ANTIOQUIA",
        "ciuu": "05120",
        "departamento": ""
    },
    {
        "idCiudad": "25123",
        "nombre": "CACHIPAY - CUNDINAMARCA",
        "ciuu": "25123",
        "departamento": ""
    },
    {
        "idCiudad": "54128",
        "nombre": "CACHIRA - N. DE SANTANDER",
        "ciuu": "54128",
        "departamento": ""
    },
    {
        "idCiudad": "54125",
        "nombre": "CACOTA - N. DE SANTANDER",
        "ciuu": "54125",
        "departamento": ""
    },
    {
        "idCiudad": "05125",
        "nombre": "CAICEDO - ANTIOQUIA",
        "ciuu": "05125",
        "departamento": ""
    },
    {
        "idCiudad": "76122",
        "nombre": "CAICEDONIA - VALLE DEL CAUCA",
        "ciuu": "76122",
        "departamento": ""
    },
    {
        "idCiudad": "70124",
        "nombre": "CAIMITO - SUCRE",
        "ciuu": "70124",
        "departamento": ""
    },
    {
        "idCiudad": "73124",
        "nombre": "CAJAMARCA - TOLIMA",
        "ciuu": "73124",
        "departamento": ""
    },
    {
        "idCiudad": "19130",
        "nombre": "CAJIBIO - CAUCA",
        "ciuu": "19130",
        "departamento": ""
    },
    {
        "idCiudad": "25126",
        "nombre": "CAJICA - CUNDINAMARCA",
        "ciuu": "25126",
        "departamento": ""
    },
    {
        "idCiudad": "13140",
        "nombre": "CALAMAR - BOLIVAR",
        "ciuu": "13140",
        "departamento": ""
    },
    {
        "idCiudad": "95015",
        "nombre": "CALAMAR - GUAVIARE",
        "ciuu": "95015",
        "departamento": ""
    },
    {
        "idCiudad": "63130",
        "nombre": "CALARCA - QUINDIO",
        "ciuu": "63130",
        "departamento": ""
    },
    {
        "idCiudad": "05129",
        "nombre": "CALDAS - ANTIOQUIA",
        "ciuu": "05129",
        "departamento": ""
    },
    {
        "idCiudad": "15131",
        "nombre": "CALDAS - BOYACA",
        "ciuu": "15131",
        "departamento": ""
    },
    {
        "idCiudad": "19137",
        "nombre": "CALDONO - CAUCA",
        "ciuu": "19137",
        "departamento": ""
    },
    {
        "idCiudad": "76001",
        "nombre": "CALI - VALLE DEL CAUCA",
        "ciuu": "76001",
        "departamento": ""
    },
    {
        "idCiudad": "68132",
        "nombre": "CALIFORNIA - SANTANDER",
        "ciuu": "68132",
        "departamento": ""
    },
    {
        "idCiudad": "76126",
        "nombre": "CALIMA - VALLE DEL CAUCA",
        "ciuu": "76126",
        "departamento": ""
    },
    {
        "idCiudad": "19142",
        "nombre": "CALOTO - CAUCA",
        "ciuu": "19142",
        "departamento": ""
    },
    {
        "idCiudad": "05134",
        "nombre": "CAMPAMENTO - ANTIOQUIA",
        "ciuu": "05134",
        "departamento": ""
    },
    {
        "idCiudad": "08137",
        "nombre": "CAMPO DE LA CRUZ - ATLANTICO",
        "ciuu": "08137",
        "departamento": ""
    },
    {
        "idCiudad": "41132",
        "nombre": "CAMPOALEGRE - HUILA",
        "ciuu": "41132",
        "departamento": ""
    },
    {
        "idCiudad": "15135",
        "nombre": "CAMPOHERMOSO - BOYACA",
        "ciuu": "15135",
        "departamento": ""
    },
    {
        "idCiudad": "23090",
        "nombre": "CANALETE - CORDOBA",
        "ciuu": "23090",
        "departamento": ""
    },
    {
        "idCiudad": "08141",
        "nombre": "CANDELARIA - ATLANTICO",
        "ciuu": "08141",
        "departamento": ""
    },
    {
        "idCiudad": "76130",
        "nombre": "CANDELARIA - VALLE DEL CAUCA",
        "ciuu": "76130",
        "departamento": ""
    },
    {
        "idCiudad": "13160",
        "nombre": "CANTAGALLO - BOLIVAR",
        "ciuu": "13160",
        "departamento": ""
    },
    {
        "idCiudad": "05138",
        "nombre": "CAÑASGORDAS - ANTIOQUIA",
        "ciuu": "05138",
        "departamento": ""
    },
    {
        "idCiudad": "25148",
        "nombre": "CAPARRAPI - CUNDINAMARCA",
        "ciuu": "25148",
        "departamento": ""
    },
    {
        "idCiudad": "68147",
        "nombre": "CAPITANEJO - SANTANDER",
        "ciuu": "68147",
        "departamento": ""
    },
    {
        "idCiudad": "25151",
        "nombre": "CAQUEZA - CUNDINAMARCA",
        "ciuu": "25151",
        "departamento": ""
    },
    {
        "idCiudad": "05142",
        "nombre": "CARACOLI - ANTIOQUIA",
        "ciuu": "05142",
        "departamento": ""
    },
    {
        "idCiudad": "05145",
        "nombre": "CARAMANTA - ANTIOQUIA",
        "ciuu": "05145",
        "departamento": ""
    },
    {
        "idCiudad": "68152",
        "nombre": "CARCASI - SANTANDER",
        "ciuu": "68152",
        "departamento": ""
    },
    {
        "idCiudad": "05147",
        "nombre": "CAREPA - ANTIOQUIA",
        "ciuu": "05147",
        "departamento": ""
    },
    {
        "idCiudad": "73148",
        "nombre": "CARMEN DE APICALA - TOLIMA",
        "ciuu": "73148",
        "departamento": ""
    },
    {
        "idCiudad": "25154",
        "nombre": "CARMEN DE CARUPA - CUNDINAMARC",
        "ciuu": "25154",
        "departamento": ""
    },
    {
        "idCiudad": "27150",
        "nombre": "CARMEN DEL DARIEN - CHOCO",
        "ciuu": "27150",
        "departamento": ""
    },
    {
        "idCiudad": "05150",
        "nombre": "CAROLINA - ANTIOQUIA",
        "ciuu": "05150",
        "departamento": ""
    },
    {
        "idCiudad": "13001",
        "nombre": "CARTAGENA - BOLIVAR",
        "ciuu": "13001",
        "departamento": ""
    },
    {
        "idCiudad": "18150",
        "nombre": "CARTAGENA DEL CHAIRA - CAQUETA",
        "ciuu": "18150",
        "departamento": ""
    },
    {
        "idCiudad": "76147",
        "nombre": "CARTAGO - VALLE DEL CAUCA",
        "ciuu": "76147",
        "departamento": ""
    },
    {
        "idCiudad": "97161",
        "nombre": "CARURU - VAUPES",
        "ciuu": "97161",
        "departamento": ""
    },
    {
        "idCiudad": "73152",
        "nombre": "CASABIANCA - TOLIMA",
        "ciuu": "73152",
        "departamento": ""
    },
    {
        "idCiudad": "50150",
        "nombre": "CASTILLA LA NUEVA - META",
        "ciuu": "50150",
        "departamento": ""
    },
    {
        "idCiudad": "05154",
        "nombre": "CAUCASIA - ANTIOQUIA",
        "ciuu": "05154",
        "departamento": ""
    },
    {
        "idCiudad": "68160",
        "nombre": "CEPITA - SANTANDER",
        "ciuu": "68160",
        "departamento": ""
    },
    {
        "idCiudad": "23162",
        "nombre": "CERETE - CORDOBA",
        "ciuu": "23162",
        "departamento": ""
    },
    {
        "idCiudad": "15162",
        "nombre": "CERINZA - BOYACA",
        "ciuu": "15162",
        "departamento": ""
    },
    {
        "idCiudad": "68162",
        "nombre": "CERRITO - SANTANDER",
        "ciuu": "68162",
        "departamento": ""
    },
    {
        "idCiudad": "47161",
        "nombre": "CERRO SAN ANTONIO - MAGDALENA",
        "ciuu": "47161",
        "departamento": ""
    },
    {
        "idCiudad": "27160",
        "nombre": "CERTEGUI - CHOCO",
        "ciuu": "27160",
        "departamento": ""
    },
    {
        "idCiudad": "52240",
        "nombre": "CHACHAGsI - NARIÑO",
        "ciuu": "52240",
        "departamento": ""
    },
    {
        "idCiudad": "25168",
        "nombre": "CHAGUANI - CUNDINAMARCA",
        "ciuu": "25168",
        "departamento": ""
    },
    {
        "idCiudad": "70230",
        "nombre": "CHALAN - SUCRE",
        "ciuu": "70230",
        "departamento": ""
    },
    {
        "idCiudad": "85015",
        "nombre": "CHAMEZA - CASANARE",
        "ciuu": "85015",
        "departamento": ""
    },
    {
        "idCiudad": "73168",
        "nombre": "CHAPARRAL - TOLIMA",
        "ciuu": "73168",
        "departamento": ""
    },
    {
        "idCiudad": "68167",
        "nombre": "CHARALA - SANTANDER",
        "ciuu": "68167",
        "departamento": ""
    },
    {
        "idCiudad": "68169",
        "nombre": "CHARTA - SANTANDER",
        "ciuu": "68169",
        "departamento": ""
    },
    {
        "idCiudad": "25175",
        "nombre": "CHIA - CUNDINAMARCA",
        "ciuu": "25175",
        "departamento": ""
    },
    {
        "idCiudad": "47170",
        "nombre": "CHIBOLO - MAGDALENA",
        "ciuu": "47170",
        "departamento": ""
    },
    {
        "idCiudad": "05172",
        "nombre": "CHIGORODO - ANTIOQUIA",
        "ciuu": "05172",
        "departamento": ""
    },
    {
        "idCiudad": "23168",
        "nombre": "CHIMA - CORDOBA",
        "ciuu": "23168",
        "departamento": ""
    },
    {
        "idCiudad": "68176",
        "nombre": "CHIMA - SANTANDER",
        "ciuu": "68176",
        "departamento": ""
    },
    {
        "idCiudad": "20175",
        "nombre": "CHIMICHAGUA - CESAR",
        "ciuu": "20175",
        "departamento": ""
    },
    {
        "idCiudad": "54172",
        "nombre": "CHINACOTA - N. DE SANTANDER",
        "ciuu": "54172",
        "departamento": ""
    },
    {
        "idCiudad": "15172",
        "nombre": "CHINAVITA - BOYACA",
        "ciuu": "15172",
        "departamento": ""
    },
    {
        "idCiudad": "17174",
        "nombre": "CHINCHINA - CALDAS",
        "ciuu": "17174",
        "departamento": ""
    },
    {
        "idCiudad": "23182",
        "nombre": "CHINU - CORDOBA",
        "ciuu": "23182",
        "departamento": ""
    },
    {
        "idCiudad": "25178",
        "nombre": "CHIPAQUE - CUNDINAMARCA",
        "ciuu": "25178",
        "departamento": ""
    },
    {
        "idCiudad": "68179",
        "nombre": "CHIPATA - SANTANDER",
        "ciuu": "68179",
        "departamento": ""
    },
    {
        "idCiudad": "15176",
        "nombre": "CHIQUINQUIRA - BOYACA",
        "ciuu": "15176",
        "departamento": ""
    },
    {
        "idCiudad": "15232",
        "nombre": "CHIQUIZA - BOYACA",
        "ciuu": "15232",
        "departamento": ""
    },
    {
        "idCiudad": "20178",
        "nombre": "CHIRIGUANA - CESAR",
        "ciuu": "20178",
        "departamento": ""
    },
    {
        "idCiudad": "15180",
        "nombre": "CHISCAS - BOYACA",
        "ciuu": "15180",
        "departamento": ""
    },
    {
        "idCiudad": "15183",
        "nombre": "CHITA - BOYACA",
        "ciuu": "15183",
        "departamento": ""
    },
    {
        "idCiudad": "54174",
        "nombre": "CHITAGA - N. DE SANTANDER",
        "ciuu": "54174",
        "departamento": ""
    },
    {
        "idCiudad": "15185",
        "nombre": "CHITARAQUE - BOYACA",
        "ciuu": "15185",
        "departamento": ""
    },
    {
        "idCiudad": "15187",
        "nombre": "CHIVATA - BOYACA",
        "ciuu": "15187",
        "departamento": ""
    },
    {
        "idCiudad": "15236",
        "nombre": "CHIVOR - BOYACA",
        "ciuu": "15236",
        "departamento": ""
    },
    {
        "idCiudad": "25181",
        "nombre": "CHOACHI - CUNDINAMARCA",
        "ciuu": "25181",
        "departamento": ""
    },
    {
        "idCiudad": "25183",
        "nombre": "CHOCONTA - CUNDINAMARCA",
        "ciuu": "25183",
        "departamento": ""
    },
    {
        "idCiudad": "13188",
        "nombre": "CICUCO - BOLIVAR",
        "ciuu": "13188",
        "departamento": ""
    },
    {
        "idCiudad": "47189",
        "nombre": "CIENAGA - MAGDALENA",
        "ciuu": "47189",
        "departamento": ""
    },
    {
        "idCiudad": "23189",
        "nombre": "CIENAGA DE ORO - CORDOBA",
        "ciuu": "23189",
        "departamento": ""
    },
    {
        "idCiudad": "15189",
        "nombre": "CIENEGA - BOYACA",
        "ciuu": "15189",
        "departamento": ""
    },
    {
        "idCiudad": "68190",
        "nombre": "CIMITARRA - SANTANDER",
        "ciuu": "68190",
        "departamento": ""
    },
    {
        "idCiudad": "63190",
        "nombre": "CIRCASIA - QUINDIO",
        "ciuu": "63190",
        "departamento": ""
    },
    {
        "idCiudad": "05190",
        "nombre": "CISNEROS - ANTIOQUIA",
        "ciuu": "05190",
        "departamento": ""
    },
    {
        "idCiudad": "05101",
        "nombre": "CIUDAD BOLIVAR - ANTIOQUIA",
        "ciuu": "05101",
        "departamento": ""
    },
    {
        "idCiudad": "13222",
        "nombre": "CLEMENCIA - BOLIVAR",
        "ciuu": "13222",
        "departamento": ""
    },
    {
        "idCiudad": "05197",
        "nombre": "COCORNA - ANTIOQUIA",
        "ciuu": "05197",
        "departamento": ""
    },
    {
        "idCiudad": "73200",
        "nombre": "COELLO - TOLIMA",
        "ciuu": "73200",
        "departamento": ""
    },
    {
        "idCiudad": "25200",
        "nombre": "COGUA - CUNDINAMARCA",
        "ciuu": "25200",
        "departamento": ""
    },
    {
        "idCiudad": "41206",
        "nombre": "COLOMBIA - HUILA",
        "ciuu": "41206",
        "departamento": ""
    },
    {
        "idCiudad": "52203",
        "nombre": "COLON - NARIÑO",
        "ciuu": "52203",
        "departamento": ""
    },
    {
        "idCiudad": "86219",
        "nombre": "COLON - PUTUMAYO",
        "ciuu": "86219",
        "departamento": ""
    },
    {
        "idCiudad": "70204",
        "nombre": "COLOSO - SUCRE",
        "ciuu": "70204",
        "departamento": ""
    },
    {
        "idCiudad": "15204",
        "nombre": "COMBITA - BOYACA",
        "ciuu": "15204",
        "departamento": ""
    },
    {
        "idCiudad": "05206",
        "nombre": "CONCEPCION - ANTIOQUIA",
        "ciuu": "05206",
        "departamento": ""
    },
    {
        "idCiudad": "68207",
        "nombre": "CONCEPCION - SANTANDER",
        "ciuu": "68207",
        "departamento": ""
    },
    {
        "idCiudad": "05209",
        "nombre": "CONCORDIA - ANTIOQUIA",
        "ciuu": "05209",
        "departamento": ""
    },
    {
        "idCiudad": "47205",
        "nombre": "CONCORDIA - MAGDALENA",
        "ciuu": "47205",
        "departamento": ""
    },
    {
        "idCiudad": "27205",
        "nombre": "CONDOTO - CHOCO",
        "ciuu": "27205",
        "departamento": ""
    },
    {
        "idCiudad": "68209",
        "nombre": "CONFINES - SANTANDER",
        "ciuu": "68209",
        "departamento": ""
    },
    {
        "idCiudad": "52207",
        "nombre": "CONSACA - NARIÑO",
        "ciuu": "52207",
        "departamento": ""
    },
    {
        "idCiudad": "52210",
        "nombre": "CONTADERO - NARIÑO",
        "ciuu": "52210",
        "departamento": ""
    },
    {
        "idCiudad": "68211",
        "nombre": "CONTRATACION - SANTANDER",
        "ciuu": "68211",
        "departamento": ""
    },
    {
        "idCiudad": "54206",
        "nombre": "CONVENCION - N. DE SANTANDER",
        "ciuu": "54206",
        "departamento": ""
    },
    {
        "idCiudad": "05212",
        "nombre": "COPACABANA - ANTIOQUIA",
        "ciuu": "05212",
        "departamento": ""
    },
    {
        "idCiudad": "15212",
        "nombre": "COPER - BOYACA",
        "ciuu": "15212",
        "departamento": ""
    },
    {
        "idCiudad": "13212",
        "nombre": "CORDOBA - BOLIVAR",
        "ciuu": "13212",
        "departamento": ""
    },
    {
        "idCiudad": "52215",
        "nombre": "CORDOBA - NARIÑO",
        "ciuu": "52215",
        "departamento": ""
    },
    {
        "idCiudad": "63212",
        "nombre": "CORDOBA - QUINDIO",
        "ciuu": "63212",
        "departamento": ""
    },
    {
        "idCiudad": "19212",
        "nombre": "CORINTO - CAUCA",
        "ciuu": "19212",
        "departamento": ""
    },
    {
        "idCiudad": "68217",
        "nombre": "COROMORO - SANTANDER",
        "ciuu": "68217",
        "departamento": ""
    },
    {
        "idCiudad": "70215",
        "nombre": "COROZAL - SUCRE",
        "ciuu": "70215",
        "departamento": ""
    },
    {
        "idCiudad": "15215",
        "nombre": "CORRALES - BOYACA",
        "ciuu": "15215",
        "departamento": ""
    },
    {
        "idCiudad": "25214",
        "nombre": "COTA - CUNDINAMARCA",
        "ciuu": "25214",
        "departamento": ""
    },
    {
        "idCiudad": "23300",
        "nombre": "COTORRA - CORDOBA",
        "ciuu": "23300",
        "departamento": ""
    },
    {
        "idCiudad": "15218",
        "nombre": "COVARACHIA - BOYACA",
        "ciuu": "15218",
        "departamento": ""
    },
    {
        "idCiudad": "70221",
        "nombre": "COVEÑAS - SUCRE",
        "ciuu": "70221",
        "departamento": ""
    },
    {
        "idCiudad": "73217",
        "nombre": "COYAIMA - TOLIMA",
        "ciuu": "73217",
        "departamento": ""
    },
    {
        "idCiudad": "81220",
        "nombre": "CRAVO NORTE - ARAUCA",
        "ciuu": "81220",
        "departamento": ""
    },
    {
        "idCiudad": "52224",
        "nombre": "CUASPUD - NARIÑO",
        "ciuu": "52224",
        "departamento": ""
    },
    {
        "idCiudad": "15223",
        "nombre": "CUBARA - BOYACA",
        "ciuu": "15223",
        "departamento": ""
    },
    {
        "idCiudad": "50223",
        "nombre": "CUBARRAL - META",
        "ciuu": "50223",
        "departamento": ""
    },
    {
        "idCiudad": "15224",
        "nombre": "CUCAITA - BOYACA",
        "ciuu": "15224",
        "departamento": ""
    },
    {
        "idCiudad": "25224",
        "nombre": "CUCUNUBA - CUNDINAMARCA",
        "ciuu": "25224",
        "departamento": ""
    },
    {
        "idCiudad": "54001",
        "nombre": "CUCUTA - N. DE SANTANDER",
        "ciuu": "54001",
        "departamento": ""
    },
    {
        "idCiudad": "54223",
        "nombre": "CUCUTILLA - N. DE SANTANDER",
        "ciuu": "54223",
        "departamento": ""
    },
    {
        "idCiudad": "15226",
        "nombre": "CUITIVA - BOYACA",
        "ciuu": "15226",
        "departamento": ""
    },
    {
        "idCiudad": "50226",
        "nombre": "CUMARAL - META",
        "ciuu": "50226",
        "departamento": ""
    },
    {
        "idCiudad": "99773",
        "nombre": "CUMARIBO - VICHADA",
        "ciuu": "99773",
        "departamento": ""
    },
    {
        "idCiudad": "52227",
        "nombre": "CUMBAL - NARIÑO",
        "ciuu": "52227",
        "departamento": ""
    },
    {
        "idCiudad": "52233",
        "nombre": "CUMBITARA - NARIÑO",
        "ciuu": "52233",
        "departamento": ""
    },
    {
        "idCiudad": "73226",
        "nombre": "CUNDAY - TOLIMA",
        "ciuu": "73226",
        "departamento": ""
    },
    {
        "idCiudad": "18205",
        "nombre": "CURILLO - CAQUETA",
        "ciuu": "18205",
        "departamento": ""
    },
    {
        "idCiudad": "68229",
        "nombre": "CURITI - SANTANDER",
        "ciuu": "68229",
        "departamento": ""
    },
    {
        "idCiudad": "20228",
        "nombre": "CURUMANI - CESAR",
        "ciuu": "20228",
        "departamento": ""
    },
    {
        "idCiudad": "05234",
        "nombre": "DABEIBA - ANTIOQUIA",
        "ciuu": "05234",
        "departamento": ""
    },
    {
        "idCiudad": "76233",
        "nombre": "DAGUA - VALLE DEL CAUCA",
        "ciuu": "76233",
        "departamento": ""
    },
    {
        "idCiudad": "44090",
        "nombre": "DIBULLA - LA GUAJIRA",
        "ciuu": "44090",
        "departamento": ""
    },
    {
        "idCiudad": "44098",
        "nombre": "DISTRACCION - LA GUAJIRA",
        "ciuu": "44098",
        "departamento": ""
    },
    {
        "idCiudad": "73236",
        "nombre": "DOLORES - TOLIMA",
        "ciuu": "73236",
        "departamento": ""
    },
    {
        "idCiudad": "05237",
        "nombre": "DON MATIAS - ANTIOQUIA",
        "ciuu": "05237",
        "departamento": ""
    },
    {
        "idCiudad": "66170",
        "nombre": "DOSQUEBRADAS - RISARALDA",
        "ciuu": "66170",
        "departamento": ""
    },
    {
        "idCiudad": "15238",
        "nombre": "DUITAMA - BOYACA",
        "ciuu": "15238",
        "departamento": ""
    },
    {
        "idCiudad": "54239",
        "nombre": "DURANIA - N. DE SANTANDER",
        "ciuu": "54239",
        "departamento": ""
    },
    {
        "idCiudad": "05240",
        "nombre": "EBEJICO - ANTIOQUIA",
        "ciuu": "05240",
        "departamento": ""
    },
    {
        "idCiudad": "76243",
        "nombre": "EL AGUILA - VALLE DEL CAUCA",
        "ciuu": "76243",
        "departamento": ""
    },
    {
        "idCiudad": "05250",
        "nombre": "EL BAGRE - ANTIOQUIA",
        "ciuu": "05250",
        "departamento": ""
    },
    {
        "idCiudad": "47245",
        "nombre": "EL BANCO - MAGDALENA",
        "ciuu": "47245",
        "departamento": ""
    },
    {
        "idCiudad": "76246",
        "nombre": "EL CAIRO - VALLE DEL CAUCA",
        "ciuu": "76246",
        "departamento": ""
    },
    {
        "idCiudad": "50245",
        "nombre": "EL CALVARIO - META",
        "ciuu": "50245",
        "departamento": ""
    },
    {
        "idCiudad": "27135",
        "nombre": "EL CANTON DEL SAN PABLO - CHOC",
        "ciuu": "27135",
        "departamento": ""
    },
    {
        "idCiudad": "54245",
        "nombre": "EL CARMEN - N. DE SANTANDER",
        "ciuu": "54245",
        "departamento": ""
    },
    {
        "idCiudad": "27245",
        "nombre": "EL CARMEN DE ATRATO - CHOCO",
        "ciuu": "27245",
        "departamento": ""
    },
    {
        "idCiudad": "13244",
        "nombre": "EL CARMEN DE BOLIVAR - BOLIVAR",
        "ciuu": "13244",
        "departamento": ""
    },
    {
        "idCiudad": "68235",
        "nombre": "EL CARMEN DE CHUCURI - SANTAND",
        "ciuu": "68235",
        "departamento": ""
    },
    {
        "idCiudad": "05148",
        "nombre": "EL CARMEN DE VIBORAL - ANTIOQU",
        "ciuu": "05148",
        "departamento": ""
    },
    {
        "idCiudad": "50251",
        "nombre": "EL CASTILLO - META",
        "ciuu": "50251",
        "departamento": ""
    },
    {
        "idCiudad": "76248",
        "nombre": "EL CERRITO - VALLE DEL CAUCA",
        "ciuu": "76248",
        "departamento": ""
    },
    {
        "idCiudad": "52250",
        "nombre": "EL CHARCO - NARIÑO",
        "ciuu": "52250",
        "departamento": ""
    },
    {
        "idCiudad": "15244",
        "nombre": "EL COCUY - BOYACA",
        "ciuu": "15244",
        "departamento": ""
    },
    {
        "idCiudad": "25245",
        "nombre": "EL COLEGIO - CUNDINAMARCA",
        "ciuu": "25245",
        "departamento": ""
    },
    {
        "idCiudad": "20238",
        "nombre": "EL COPEY - CESAR",
        "ciuu": "20238",
        "departamento": ""
    },
    {
        "idCiudad": "18247",
        "nombre": "EL DONCELLO - CAQUETA",
        "ciuu": "18247",
        "departamento": ""
    },
    {
        "idCiudad": "50270",
        "nombre": "EL DORADO - META",
        "ciuu": "50270",
        "departamento": ""
    },
    {
        "idCiudad": "76250",
        "nombre": "EL DOVIO - VALLE DEL CAUCA",
        "ciuu": "76250",
        "departamento": ""
    },
    {
        "idCiudad": "91263",
        "nombre": "EL ENCANTO - AMAZONAS",
        "ciuu": "91263",
        "departamento": ""
    },
    {
        "idCiudad": "15248",
        "nombre": "EL ESPINO - BOYACA",
        "ciuu": "15248",
        "departamento": ""
    },
    {
        "idCiudad": "68245",
        "nombre": "EL GUACAMAYO - SANTANDER",
        "ciuu": "68245",
        "departamento": ""
    },
    {
        "idCiudad": "13248",
        "nombre": "EL GUAMO - BOLIVAR",
        "ciuu": "13248",
        "departamento": ""
    },
    {
        "idCiudad": "27250",
        "nombre": "EL LITORAL DEL SAN JUAN - CHOC",
        "ciuu": "27250",
        "departamento": ""
    },
    {
        "idCiudad": "44110",
        "nombre": "EL MOLINO - LA GUAJIRA",
        "ciuu": "44110",
        "departamento": ""
    },
    {
        "idCiudad": "20250",
        "nombre": "EL PASO - CESAR",
        "ciuu": "20250",
        "departamento": ""
    },
    {
        "idCiudad": "18256",
        "nombre": "EL PAUJIL - CAQUETA",
        "ciuu": "18256",
        "departamento": ""
    },
    {
        "idCiudad": "52254",
        "nombre": "EL PEÑOL - NARIÑO",
        "ciuu": "52254",
        "departamento": ""
    },
    {
        "idCiudad": "13268",
        "nombre": "EL PEÑON - BOLIVAR",
        "ciuu": "13268",
        "departamento": ""
    },
    {
        "idCiudad": "25258",
        "nombre": "EL PEÑON - CUNDINAMARCA",
        "ciuu": "25258",
        "departamento": ""
    },
    {
        "idCiudad": "68250",
        "nombre": "EL PEÑON - SANTANDER",
        "ciuu": "68250",
        "departamento": ""
    },
    {
        "idCiudad": "47258",
        "nombre": "EL PIÑON - MAGDALENA",
        "ciuu": "47258",
        "departamento": ""
    },
    {
        "idCiudad": "68255",
        "nombre": "EL PLAYON - SANTANDER",
        "ciuu": "68255",
        "departamento": ""
    },
    {
        "idCiudad": "47268",
        "nombre": "EL RETEN - MAGDALENA",
        "ciuu": "47268",
        "departamento": ""
    },
    {
        "idCiudad": "95025",
        "nombre": "EL RETORNO - GUAVIARE",
        "ciuu": "95025",
        "departamento": ""
    },
    {
        "idCiudad": "70233",
        "nombre": "EL ROBLE - SUCRE",
        "ciuu": "70233",
        "departamento": ""
    },
    {
        "idCiudad": "25260",
        "nombre": "EL ROSAL - CUNDINAMARCA",
        "ciuu": "25260",
        "departamento": ""
    },
    {
        "idCiudad": "52256",
        "nombre": "EL ROSARIO - NARIÑO",
        "ciuu": "52256",
        "departamento": ""
    },
    {
        "idCiudad": "05697",
        "nombre": "EL SANTUARIO - ANTIOQUIA",
        "ciuu": "05697",
        "departamento": ""
    },
    {
        "idCiudad": "52258",
        "nombre": "EL TABLON DE GOMEZ - NARIÑO",
        "ciuu": "52258",
        "departamento": ""
    },
    {
        "idCiudad": "19256",
        "nombre": "EL TAMBO - CAUCA",
        "ciuu": "19256",
        "departamento": ""
    },
    {
        "idCiudad": "52260",
        "nombre": "EL TAMBO - NARIÑO",
        "ciuu": "52260",
        "departamento": ""
    },
    {
        "idCiudad": "54250",
        "nombre": "EL TARRA - N. DE SANTANDER",
        "ciuu": "54250",
        "departamento": ""
    },
    {
        "idCiudad": "54261",
        "nombre": "EL ZULIA - N. DE SANTANDER",
        "ciuu": "54261",
        "departamento": ""
    },
    {
        "idCiudad": "41244",
        "nombre": "ELIAS - HUILA",
        "ciuu": "41244",
        "departamento": ""
    },
    {
        "idCiudad": "68264",
        "nombre": "ENCINO - SANTANDER",
        "ciuu": "68264",
        "departamento": ""
    },
    {
        "idCiudad": "68266",
        "nombre": "ENCISO - SANTANDER",
        "ciuu": "68266",
        "departamento": ""
    },
    {
        "idCiudad": "05264",
        "nombre": "ENTRERRIOS - ANTIOQUIA",
        "ciuu": "05264",
        "departamento": ""
    },
    {
        "idCiudad": "05266",
        "nombre": "ENVIGADO - ANTIOQUIA",
        "ciuu": "05266",
        "departamento": ""
    },
    {
        "idCiudad": "73268",
        "nombre": "ESPINAL - TOLIMA",
        "ciuu": "73268",
        "departamento": ""
    },
    {
        "idCiudad": "25269",
        "nombre": "FACATATIVA - CUNDINAMARCA",
        "ciuu": "25269",
        "departamento": ""
    },
    {
        "idCiudad": "73270",
        "nombre": "FALAN - TOLIMA",
        "ciuu": "73270",
        "departamento": ""
    },
    {
        "idCiudad": "17272",
        "nombre": "FILADELFIA - CALDAS",
        "ciuu": "17272",
        "departamento": ""
    },
    {
        "idCiudad": "63272",
        "nombre": "FILANDIA - QUINDIO",
        "ciuu": "63272",
        "departamento": ""
    },
    {
        "idCiudad": "15272",
        "nombre": "FIRAVITOBA - BOYACA",
        "ciuu": "15272",
        "departamento": ""
    },
    {
        "idCiudad": "73275",
        "nombre": "FLANDES - TOLIMA",
        "ciuu": "73275",
        "departamento": ""
    },
    {
        "idCiudad": "18001",
        "nombre": "FLORENCIA - CAQUETA",
        "ciuu": "18001",
        "departamento": ""
    },
    {
        "idCiudad": "19290",
        "nombre": "FLORENCIA - CAUCA",
        "ciuu": "19290",
        "departamento": ""
    },
    {
        "idCiudad": "15276",
        "nombre": "FLORESTA - BOYACA",
        "ciuu": "15276",
        "departamento": ""
    },
    {
        "idCiudad": "68271",
        "nombre": "FLORIAN - SANTANDER",
        "ciuu": "68271",
        "departamento": ""
    },
    {
        "idCiudad": "76275",
        "nombre": "FLORIDA - VALLE DEL CAUCA",
        "ciuu": "76275",
        "departamento": ""
    },
    {
        "idCiudad": "68276",
        "nombre": "FLORIDABLANCA - SANTANDER",
        "ciuu": "68276",
        "departamento": ""
    },
    {
        "idCiudad": "25279",
        "nombre": "FOMEQUE - CUNDINAMARCA",
        "ciuu": "25279",
        "departamento": ""
    },
    {
        "idCiudad": "44279",
        "nombre": "FONSECA - LA GUAJIRA",
        "ciuu": "44279",
        "departamento": ""
    },
    {
        "idCiudad": "81300",
        "nombre": "FORTUL - ARAUCA",
        "ciuu": "81300",
        "departamento": ""
    },
    {
        "idCiudad": "25281",
        "nombre": "FOSCA - CUNDINAMARCA",
        "ciuu": "25281",
        "departamento": ""
    },
    {
        "idCiudad": "52520",
        "nombre": "FRANCISCO PIZARRO - NARIÑO",
        "ciuu": "52520",
        "departamento": ""
    },
    {
        "idCiudad": "05282",
        "nombre": "FREDONIA - ANTIOQUIA",
        "ciuu": "05282",
        "departamento": ""
    },
    {
        "idCiudad": "73283",
        "nombre": "FRESNO - TOLIMA",
        "ciuu": "73283",
        "departamento": ""
    },
    {
        "idCiudad": "05284",
        "nombre": "FRONTINO - ANTIOQUIA",
        "ciuu": "05284",
        "departamento": ""
    },
    {
        "idCiudad": "50287",
        "nombre": "FUENTE DE ORO - META",
        "ciuu": "50287",
        "departamento": ""
    },
    {
        "idCiudad": "47288",
        "nombre": "FUNDACION - MAGDALENA",
        "ciuu": "47288",
        "departamento": ""
    },
    {
        "idCiudad": "52287",
        "nombre": "FUNES - NARIÑO",
        "ciuu": "52287",
        "departamento": ""
    },
    {
        "idCiudad": "25286",
        "nombre": "FUNZA - CUNDINAMARCA",
        "ciuu": "25286",
        "departamento": ""
    },
    {
        "idCiudad": "25288",
        "nombre": "FUQUENE - CUNDINAMARCA",
        "ciuu": "25288",
        "departamento": ""
    },
    {
        "idCiudad": "25290",
        "nombre": "FUSAGASUGA - CUNDINAMARCA",
        "ciuu": "25290",
        "departamento": ""
    },
    {
        "idCiudad": "25293",
        "nombre": "GACHALA - CUNDINAMARCA",
        "ciuu": "25293",
        "departamento": ""
    },
    {
        "idCiudad": "25295",
        "nombre": "GACHANCIPA - CUNDINAMARCA",
        "ciuu": "25295",
        "departamento": ""
    },
    {
        "idCiudad": "15293",
        "nombre": "GACHANTIVA - BOYACA",
        "ciuu": "15293",
        "departamento": ""
    },
    {
        "idCiudad": "25297",
        "nombre": "GACHETA - CUNDINAMARCA",
        "ciuu": "25297",
        "departamento": ""
    },
    {
        "idCiudad": "68296",
        "nombre": "GALAN - SANTANDER",
        "ciuu": "68296",
        "departamento": ""
    },
    {
        "idCiudad": "08296",
        "nombre": "GALAPA - ATLANTICO",
        "ciuu": "08296",
        "departamento": ""
    },
    {
        "idCiudad": "70235",
        "nombre": "GALERAS - SUCRE",
        "ciuu": "70235",
        "departamento": ""
    },
    {
        "idCiudad": "25299",
        "nombre": "GAMA - CUNDINAMARCA",
        "ciuu": "25299",
        "departamento": ""
    },
    {
        "idCiudad": "20295",
        "nombre": "GAMARRA - CESAR",
        "ciuu": "20295",
        "departamento": ""
    },
    {
        "idCiudad": "68298",
        "nombre": "GAMBITA - SANTANDER",
        "ciuu": "68298",
        "departamento": ""
    },
    {
        "idCiudad": "15296",
        "nombre": "GAMEZA - BOYACA",
        "ciuu": "15296",
        "departamento": ""
    },
    {
        "idCiudad": "15299",
        "nombre": "GARAGOA - BOYACA",
        "ciuu": "15299",
        "departamento": ""
    },
    {
        "idCiudad": "41298",
        "nombre": "GARZON - HUILA",
        "ciuu": "41298",
        "departamento": ""
    },
    {
        "idCiudad": "63302",
        "nombre": "GENOVA - QUINDIO",
        "ciuu": "63302",
        "departamento": ""
    },
    {
        "idCiudad": "41306",
        "nombre": "GIGANTE - HUILA",
        "ciuu": "41306",
        "departamento": ""
    },
    {
        "idCiudad": "76306",
        "nombre": "GINEBRA - VALLE DEL CAUCA",
        "ciuu": "76306",
        "departamento": ""
    },
    {
        "idCiudad": "05306",
        "nombre": "GIRALDO - ANTIOQUIA",
        "ciuu": "05306",
        "departamento": ""
    },
    {
        "idCiudad": "25307",
        "nombre": "GIRARDOT - CUNDINAMARCA",
        "ciuu": "25307",
        "departamento": ""
    },
    {
        "idCiudad": "05308",
        "nombre": "GIRARDOTA - ANTIOQUIA",
        "ciuu": "05308",
        "departamento": ""
    },
    {
        "idCiudad": "68307",
        "nombre": "GIRON - SANTANDER",
        "ciuu": "68307",
        "departamento": ""
    },
    {
        "idCiudad": "05310",
        "nombre": "GOMEZ PLATA - ANTIOQUIA",
        "ciuu": "05310",
        "departamento": ""
    },
    {
        "idCiudad": "20310",
        "nombre": "GONZALEZ - CESAR",
        "ciuu": "20310",
        "departamento": ""
    },
    {
        "idCiudad": "54313",
        "nombre": "GRAMALOTE - N. DE SANTANDER",
        "ciuu": "54313",
        "departamento": ""
    },
    {
        "idCiudad": "05313",
        "nombre": "GRANADA - ANTIOQUIA",
        "ciuu": "05313",
        "departamento": ""
    },
    {
        "idCiudad": "25312",
        "nombre": "GRANADA - CUNDINAMARCA",
        "ciuu": "25312",
        "departamento": ""
    },
    {
        "idCiudad": "50313",
        "nombre": "GRANADA - META",
        "ciuu": "50313",
        "departamento": ""
    },
    {
        "idCiudad": "68327",
        "nombre": "GsEPSA - SANTANDER",
        "ciuu": "68327",
        "departamento": ""
    },
    {
        "idCiudad": "68318",
        "nombre": "GUACA - SANTANDER",
        "ciuu": "68318",
        "departamento": ""
    },
    {
        "idCiudad": "15317",
        "nombre": "GUACAMAYAS - BOYACA",
        "ciuu": "15317",
        "departamento": ""
    },
    {
        "idCiudad": "76318",
        "nombre": "GUACARI - VALLE DEL CAUCA",
        "ciuu": "76318",
        "departamento": ""
    },
    {
        "idCiudad": "19300",
        "nombre": "GUACHENE - CAUCA",
        "ciuu": "19300",
        "departamento": ""
    },
    {
        "idCiudad": "25317",
        "nombre": "GUACHETA - CUNDINAMARCA",
        "ciuu": "25317",
        "departamento": ""
    },
    {
        "idCiudad": "52317",
        "nombre": "GUACHUCAL - NARIÑO",
        "ciuu": "52317",
        "departamento": ""
    },
    {
        "idCiudad": "76111",
        "nombre": "GUADALAJARA DE BUGA - VALLE DE",
        "ciuu": "76111",
        "departamento": ""
    },
    {
        "idCiudad": "05315",
        "nombre": "GUADALUPE - ANTIOQUIA",
        "ciuu": "05315",
        "departamento": ""
    },
    {
        "idCiudad": "41319",
        "nombre": "GUADALUPE - HUILA",
        "ciuu": "41319",
        "departamento": ""
    },
    {
        "idCiudad": "68320",
        "nombre": "GUADALUPE - SANTANDER",
        "ciuu": "68320",
        "departamento": ""
    },
    {
        "idCiudad": "25320",
        "nombre": "GUADUAS - CUNDINAMARCA",
        "ciuu": "25320",
        "departamento": ""
    },
    {
        "idCiudad": "52320",
        "nombre": "GUAITARILLA - NARIÑO",
        "ciuu": "52320",
        "departamento": ""
    },
    {
        "idCiudad": "52323",
        "nombre": "GUALMATAN - NARIÑO",
        "ciuu": "52323",
        "departamento": ""
    },
    {
        "idCiudad": "47318",
        "nombre": "GUAMAL - MAGDALENA",
        "ciuu": "47318",
        "departamento": ""
    },
    {
        "idCiudad": "50318",
        "nombre": "GUAMAL - META",
        "ciuu": "50318",
        "departamento": ""
    },
    {
        "idCiudad": "73319",
        "nombre": "GUAMO - TOLIMA",
        "ciuu": "73319",
        "departamento": ""
    },
    {
        "idCiudad": "19318",
        "nombre": "GUAPI - CAUCA",
        "ciuu": "19318",
        "departamento": ""
    },
    {
        "idCiudad": "68322",
        "nombre": "GUAPOTA - SANTANDER",
        "ciuu": "68322",
        "departamento": ""
    },
    {
        "idCiudad": "70265",
        "nombre": "GUARANDA - SUCRE",
        "ciuu": "70265",
        "departamento": ""
    },
    {
        "idCiudad": "05318",
        "nombre": "GUARNE - ANTIOQUIA",
        "ciuu": "05318",
        "departamento": ""
    },
    {
        "idCiudad": "25322",
        "nombre": "GUASCA - CUNDINAMARCA",
        "ciuu": "25322",
        "departamento": ""
    },
    {
        "idCiudad": "05321",
        "nombre": "GUATAPE - ANTIOQUIA",
        "ciuu": "05321",
        "departamento": ""
    },
    {
        "idCiudad": "25324",
        "nombre": "GUATAQUI - CUNDINAMARCA",
        "ciuu": "25324",
        "departamento": ""
    },
    {
        "idCiudad": "25326",
        "nombre": "GUATAVITA - CUNDINAMARCA",
        "ciuu": "25326",
        "departamento": ""
    },
    {
        "idCiudad": "15322",
        "nombre": "GUATEQUE - BOYACA",
        "ciuu": "15322",
        "departamento": ""
    },
    {
        "idCiudad": "66318",
        "nombre": "GUATICA - RISARALDA",
        "ciuu": "66318",
        "departamento": ""
    },
    {
        "idCiudad": "68324",
        "nombre": "GUAVATA - SANTANDER",
        "ciuu": "68324",
        "departamento": ""
    },
    {
        "idCiudad": "25328",
        "nombre": "GUAYABAL DE SIQUIMA - CUNDINAM",
        "ciuu": "25328",
        "departamento": ""
    },
    {
        "idCiudad": "25335",
        "nombre": "GUAYABETAL - CUNDINAMARCA",
        "ciuu": "25335",
        "departamento": ""
    },
    {
        "idCiudad": "15325",
        "nombre": "GUAYATA - BOYACA",
        "ciuu": "15325",
        "departamento": ""
    },
    {
        "idCiudad": "15332",
        "nombre": "GUICAN DE LA SIERRA - BOYACA",
        "ciuu": "15332",
        "departamento": ""
    },
    {
        "idCiudad": "25339",
        "nombre": "GUTIERREZ - CUNDINAMARCA",
        "ciuu": "25339",
        "departamento": ""
    },
    {
        "idCiudad": "54344",
        "nombre": "HACARI - N. DE SANTANDER",
        "ciuu": "54344",
        "departamento": ""
    },
    {
        "idCiudad": "13300",
        "nombre": "HATILLO DE LOBA - BOLIVAR",
        "ciuu": "13300",
        "departamento": ""
    },
    {
        "idCiudad": "68344",
        "nombre": "HATO - SANTANDER",
        "ciuu": "68344",
        "departamento": ""
    },
    {
        "idCiudad": "85125",
        "nombre": "HATO COROZAL - CASANARE",
        "ciuu": "85125",
        "departamento": ""
    },
    {
        "idCiudad": "44378",
        "nombre": "HATONUEVO - LA GUAJIRA",
        "ciuu": "44378",
        "departamento": ""
    },
    {
        "idCiudad": "05347",
        "nombre": "HELICONIA - ANTIOQUIA",
        "ciuu": "05347",
        "departamento": ""
    },
    {
        "idCiudad": "54347",
        "nombre": "HERRAN - N. DE SANTANDER",
        "ciuu": "54347",
        "departamento": ""
    },
    {
        "idCiudad": "73347",
        "nombre": "HERVEO - TOLIMA",
        "ciuu": "73347",
        "departamento": ""
    },
    {
        "idCiudad": "05353",
        "nombre": "HISPANIA - ANTIOQUIA",
        "ciuu": "05353",
        "departamento": ""
    },
    {
        "idCiudad": "41349",
        "nombre": "HOBO - HUILA",
        "ciuu": "41349",
        "departamento": ""
    },
    {
        "idCiudad": "73349",
        "nombre": "HONDA - TOLIMA",
        "ciuu": "73349",
        "departamento": ""
    },
    {
        "idCiudad": "73001",
        "nombre": "IBAGUE - TOLIMA",
        "ciuu": "73001",
        "departamento": ""
    },
    {
        "idCiudad": "73352",
        "nombre": "ICONONZO - TOLIMA",
        "ciuu": "73352",
        "departamento": ""
    },
    {
        "idCiudad": "52352",
        "nombre": "ILES - NARIÑO",
        "ciuu": "52352",
        "departamento": ""
    },
    {
        "idCiudad": "52354",
        "nombre": "IMUES - NARIÑO",
        "ciuu": "52354",
        "departamento": ""
    },
    {
        "idCiudad": "94001",
        "nombre": "INIRIDA - GUAINIA",
        "ciuu": "94001",
        "departamento": ""
    },
    {
        "idCiudad": "19355",
        "nombre": "INZA - CAUCA",
        "ciuu": "19355",
        "departamento": ""
    },
    {
        "idCiudad": "52356",
        "nombre": "IPIALES - NARIÑO",
        "ciuu": "52356",
        "departamento": ""
    },
    {
        "idCiudad": "41357",
        "nombre": "IQUIRA - HUILA",
        "ciuu": "41357",
        "departamento": ""
    },
    {
        "idCiudad": "41359",
        "nombre": "ISNOS - HUILA",
        "ciuu": "41359",
        "departamento": ""
    },
    {
        "idCiudad": "27361",
        "nombre": "ISTMINA - CHOCO",
        "ciuu": "27361",
        "departamento": ""
    },
    {
        "idCiudad": "05360",
        "nombre": "ITAGUI - ANTIOQUIA",
        "ciuu": "05360",
        "departamento": ""
    },
    {
        "idCiudad": "05361",
        "nombre": "ITUANGO - ANTIOQUIA",
        "ciuu": "05361",
        "departamento": ""
    },
    {
        "idCiudad": "15362",
        "nombre": "IZA - BOYACA",
        "ciuu": "15362",
        "departamento": ""
    },
    {
        "idCiudad": "19364",
        "nombre": "JAMBALO - CAUCA",
        "ciuu": "19364",
        "departamento": ""
    },
    {
        "idCiudad": "76364",
        "nombre": "JAMUNDI - VALLE DEL CAUCA",
        "ciuu": "76364",
        "departamento": ""
    },
    {
        "idCiudad": "05364",
        "nombre": "JARDIN - ANTIOQUIA",
        "ciuu": "05364",
        "departamento": ""
    },
    {
        "idCiudad": "15367",
        "nombre": "JENESANO - BOYACA",
        "ciuu": "15367",
        "departamento": ""
    },
    {
        "idCiudad": "05368",
        "nombre": "JERICO - ANTIOQUIA",
        "ciuu": "05368",
        "departamento": ""
    },
    {
        "idCiudad": "15368",
        "nombre": "JERICO - BOYACA",
        "ciuu": "15368",
        "departamento": ""
    },
    {
        "idCiudad": "25368",
        "nombre": "JERUSALEN - CUNDINAMARCA",
        "ciuu": "25368",
        "departamento": ""
    },
    {
        "idCiudad": "68368",
        "nombre": "JESUS MARIA - SANTANDER",
        "ciuu": "68368",
        "departamento": ""
    },
    {
        "idCiudad": "68370",
        "nombre": "JORDAN - SANTANDER",
        "ciuu": "68370",
        "departamento": ""
    },
    {
        "idCiudad": "08372",
        "nombre": "JUAN DE ACOSTA - ATLANTICO",
        "ciuu": "08372",
        "departamento": ""
    },
    {
        "idCiudad": "25372",
        "nombre": "JUNIN - CUNDINAMARCA",
        "ciuu": "25372",
        "departamento": ""
    },
    {
        "idCiudad": "27372",
        "nombre": "JURADO - CHOCO",
        "ciuu": "27372",
        "departamento": ""
    },
    {
        "idCiudad": "23350",
        "nombre": "LA APARTADA - CORDOBA",
        "ciuu": "23350",
        "departamento": ""
    },
    {
        "idCiudad": "41378",
        "nombre": "LA ARGENTINA - HUILA",
        "ciuu": "41378",
        "departamento": ""
    },
    {
        "idCiudad": "68377",
        "nombre": "LA BELLEZA - SANTANDER",
        "ciuu": "68377",
        "departamento": ""
    },
    {
        "idCiudad": "25377",
        "nombre": "LA CALERA - CUNDINAMARCA",
        "ciuu": "25377",
        "departamento": ""
    },
    {
        "idCiudad": "15380",
        "nombre": "LA CAPILLA - BOYACA",
        "ciuu": "15380",
        "departamento": ""
    },
    {
        "idCiudad": "05376",
        "nombre": "LA CEJA - ANTIOQUIA",
        "ciuu": "05376",
        "departamento": ""
    },
    {
        "idCiudad": "66383",
        "nombre": "LA CELIA - RISARALDA",
        "ciuu": "66383",
        "departamento": ""
    },
    {
        "idCiudad": "91405",
        "nombre": "LA CHORRERA - AMAZONAS",
        "ciuu": "91405",
        "departamento": ""
    },
    {
        "idCiudad": "52378",
        "nombre": "LA CRUZ - NARIÑO",
        "ciuu": "52378",
        "departamento": ""
    },
    {
        "idCiudad": "76377",
        "nombre": "LA CUMBRE - VALLE DEL CAUCA",
        "ciuu": "76377",
        "departamento": ""
    },
    {
        "idCiudad": "17380",
        "nombre": "LA DORADA - CALDAS",
        "ciuu": "17380",
        "departamento": ""
    },
    {
        "idCiudad": "54385",
        "nombre": "LA ESPERANZA - N. DE SANTANDER",
        "ciuu": "54385",
        "departamento": ""
    },
    {
        "idCiudad": "05380",
        "nombre": "LA ESTRELLA - ANTIOQUIA",
        "ciuu": "05380",
        "departamento": ""
    },
    {
        "idCiudad": "52381",
        "nombre": "LA FLORIDA - NARIÑO",
        "ciuu": "52381",
        "departamento": ""
    },
    {
        "idCiudad": "20383",
        "nombre": "LA GLORIA - CESAR",
        "ciuu": "20383",
        "departamento": ""
    },
    {
        "idCiudad": "94885",
        "nombre": "LA GUADALUPE - GUAINIA",
        "ciuu": "94885",
        "departamento": ""
    },
    {
        "idCiudad": "20400",
        "nombre": "LA JAGUA DE IBIRICO - CESAR",
        "ciuu": "20400",
        "departamento": ""
    },
    {
        "idCiudad": "44420",
        "nombre": "LA JAGUA DEL PILAR - LA GUAJIR",
        "ciuu": "44420",
        "departamento": ""
    },
    {
        "idCiudad": "52385",
        "nombre": "LA LLANADA - NARIÑO",
        "ciuu": "52385",
        "departamento": ""
    },
    {
        "idCiudad": "50350",
        "nombre": "LA MACARENA - META",
        "ciuu": "50350",
        "departamento": ""
    },
    {
        "idCiudad": "17388",
        "nombre": "LA MERCED - CALDAS",
        "ciuu": "17388",
        "departamento": ""
    },
    {
        "idCiudad": "25386",
        "nombre": "LA MESA - CUNDINAMARCA",
        "ciuu": "25386",
        "departamento": ""
    },
    {
        "idCiudad": "18410",
        "nombre": "LA MONTAÑITA - CAQUETA",
        "ciuu": "18410",
        "departamento": ""
    },
    {
        "idCiudad": "25394",
        "nombre": "LA PALMA - CUNDINAMARCA",
        "ciuu": "25394",
        "departamento": ""
    },
    {
        "idCiudad": "20621",
        "nombre": "LA PAZ - CESAR",
        "ciuu": "20621",
        "departamento": ""
    },
    {
        "idCiudad": "68397",
        "nombre": "LA PAZ - SANTANDER",
        "ciuu": "68397",
        "departamento": ""
    },
    {
        "idCiudad": "91407",
        "nombre": "LA PEDRERA - AMAZONAS",
        "ciuu": "91407",
        "departamento": ""
    },
    {
        "idCiudad": "25398",
        "nombre": "LA PEÑA - CUNDINAMARCA",
        "ciuu": "25398",
        "departamento": ""
    },
    {
        "idCiudad": "05390",
        "nombre": "LA PINTADA - ANTIOQUIA",
        "ciuu": "05390",
        "departamento": ""
    },
    {
        "idCiudad": "41396",
        "nombre": "LA PLATA - HUILA",
        "ciuu": "41396",
        "departamento": ""
    },
    {
        "idCiudad": "54398",
        "nombre": "LA PLAYA - N. DE SANTANDER",
        "ciuu": "54398",
        "departamento": ""
    },
    {
        "idCiudad": "99524",
        "nombre": "LA PRIMAVERA - VICHADA",
        "ciuu": "99524",
        "departamento": ""
    },
    {
        "idCiudad": "85136",
        "nombre": "LA SALINA - CASANARE",
        "ciuu": "85136",
        "departamento": ""
    },
    {
        "idCiudad": "19392",
        "nombre": "LA SIERRA - CAUCA",
        "ciuu": "19392",
        "departamento": ""
    },
    {
        "idCiudad": "63401",
        "nombre": "LA TEBAIDA - QUINDIO",
        "ciuu": "63401",
        "departamento": ""
    },
    {
        "idCiudad": "52390",
        "nombre": "LA TOLA - NARIÑO",
        "ciuu": "52390",
        "departamento": ""
    },
    {
        "idCiudad": "05400",
        "nombre": "LA UNION - ANTIOQUIA",
        "ciuu": "05400",
        "departamento": ""
    },
    {
        "idCiudad": "52399",
        "nombre": "LA UNION - NARIÑO",
        "ciuu": "52399",
        "departamento": ""
    },
    {
        "idCiudad": "70400",
        "nombre": "LA UNION - SUCRE",
        "ciuu": "70400",
        "departamento": ""
    },
    {
        "idCiudad": "76400",
        "nombre": "LA UNION - VALLE DEL CAUCA",
        "ciuu": "76400",
        "departamento": ""
    },
    {
        "idCiudad": "15403",
        "nombre": "LA UVITA - BOYACA",
        "ciuu": "15403",
        "departamento": ""
    },
    {
        "idCiudad": "19397",
        "nombre": "LA VEGA - CAUCA",
        "ciuu": "19397",
        "departamento": ""
    },
    {
        "idCiudad": "25402",
        "nombre": "LA VEGA - CUNDINAMARCA",
        "ciuu": "25402",
        "departamento": ""
    },
    {
        "idCiudad": "91430",
        "nombre": "LA VICTORIA - AMAZONAS",
        "ciuu": "91430",
        "departamento": ""
    },
    {
        "idCiudad": "15401",
        "nombre": "LA VICTORIA - BOYACA",
        "ciuu": "15401",
        "departamento": ""
    },
    {
        "idCiudad": "76403",
        "nombre": "LA VICTORIA - VALLE DEL CAUCA",
        "ciuu": "76403",
        "departamento": ""
    },
    {
        "idCiudad": "66400",
        "nombre": "LA VIRGINIA - RISARALDA",
        "ciuu": "66400",
        "departamento": ""
    },
    {
        "idCiudad": "54377",
        "nombre": "LABATECA - N. DE SANTANDER",
        "ciuu": "54377",
        "departamento": ""
    },
    {
        "idCiudad": "15377",
        "nombre": "LABRANZAGRANDE - BOYACA",
        "ciuu": "15377",
        "departamento": ""
    },
    {
        "idCiudad": "68385",
        "nombre": "LANDAZURI - SANTANDER",
        "ciuu": "68385",
        "departamento": ""
    },
    {
        "idCiudad": "68406",
        "nombre": "LEBRIJA - SANTANDER",
        "ciuu": "68406",
        "departamento": ""
    },
    {
        "idCiudad": "86573",
        "nombre": "LEGUIZAMO - PUTUMAYO",
        "ciuu": "86573",
        "departamento": ""
    },
    {
        "idCiudad": "52405",
        "nombre": "LEIVA - NARIÑO",
        "ciuu": "52405",
        "departamento": ""
    },
    {
        "idCiudad": "50400",
        "nombre": "LEJANIAS - META",
        "ciuu": "50400",
        "departamento": ""
    },
    {
        "idCiudad": "25407",
        "nombre": "LENGUAZAQUE - CUNDINAMARCA",
        "ciuu": "25407",
        "departamento": ""
    },
    {
        "idCiudad": "73408",
        "nombre": "LERIDA - TOLIMA",
        "ciuu": "73408",
        "departamento": ""
    },
    {
        "idCiudad": "91001",
        "nombre": "LETICIA - AMAZONAS",
        "ciuu": "91001",
        "departamento": ""
    },
    {
        "idCiudad": "73411",
        "nombre": "LIBANO - TOLIMA",
        "ciuu": "73411",
        "departamento": ""
    },
    {
        "idCiudad": "05411",
        "nombre": "LIBORINA - ANTIOQUIA",
        "ciuu": "05411",
        "departamento": ""
    },
    {
        "idCiudad": "52411",
        "nombre": "LINARES - NARIÑO",
        "ciuu": "52411",
        "departamento": ""
    },
    {
        "idCiudad": "27413",
        "nombre": "LLORO - CHOCO",
        "ciuu": "27413",
        "departamento": ""
    },
    {
        "idCiudad": "19418",
        "nombre": "LOPEZ - CAUCA",
        "ciuu": "19418",
        "departamento": ""
    },
    {
        "idCiudad": "23417",
        "nombre": "LORICA - CORDOBA",
        "ciuu": "23417",
        "departamento": ""
    },
    {
        "idCiudad": "52418",
        "nombre": "LOS ANDES - NARIÑO",
        "ciuu": "52418",
        "departamento": ""
    },
    {
        "idCiudad": "23419",
        "nombre": "LOS CORDOBAS - CORDOBA",
        "ciuu": "23419",
        "departamento": ""
    },
    {
        "idCiudad": "70418",
        "nombre": "LOS PALMITOS - SUCRE",
        "ciuu": "70418",
        "departamento": ""
    },
    {
        "idCiudad": "54405",
        "nombre": "LOS PATIOS - N. DE SANTANDER",
        "ciuu": "54405",
        "departamento": ""
    },
    {
        "idCiudad": "68418",
        "nombre": "LOS SANTOS - SANTANDER",
        "ciuu": "68418",
        "departamento": ""
    },
    {
        "idCiudad": "54418",
        "nombre": "LOURDES - N. DE SANTANDER",
        "ciuu": "54418",
        "departamento": ""
    },
    {
        "idCiudad": "08421",
        "nombre": "LURUACO - ATLANTICO",
        "ciuu": "08421",
        "departamento": ""
    },
    {
        "idCiudad": "15425",
        "nombre": "MACANAL - BOYACA",
        "ciuu": "15425",
        "departamento": ""
    },
    {
        "idCiudad": "68425",
        "nombre": "MACARAVITA - SANTANDER",
        "ciuu": "68425",
        "departamento": ""
    },
    {
        "idCiudad": "05425",
        "nombre": "MACEO - ANTIOQUIA",
        "ciuu": "05425",
        "departamento": ""
    },
    {
        "idCiudad": "25426",
        "nombre": "MACHETA - CUNDINAMARCA",
        "ciuu": "25426",
        "departamento": ""
    },
    {
        "idCiudad": "25430",
        "nombre": "MADRID - CUNDINAMARCA",
        "ciuu": "25430",
        "departamento": ""
    },
    {
        "idCiudad": "13430",
        "nombre": "MAGANGUE - BOLIVAR",
        "ciuu": "13430",
        "departamento": ""
    },
    {
        "idCiudad": "52427",
        "nombre": "MAGsI - NARIÑO",
        "ciuu": "52427",
        "departamento": ""
    },
    {
        "idCiudad": "13433",
        "nombre": "MAHATES - BOLIVAR",
        "ciuu": "13433",
        "departamento": ""
    },
    {
        "idCiudad": "44430",
        "nombre": "MAICAO - LA GUAJIRA",
        "ciuu": "44430",
        "departamento": ""
    },
    {
        "idCiudad": "70429",
        "nombre": "MAJAGUAL - SUCRE",
        "ciuu": "70429",
        "departamento": ""
    },
    {
        "idCiudad": "68432",
        "nombre": "MALAGA - SANTANDER",
        "ciuu": "68432",
        "departamento": ""
    },
    {
        "idCiudad": "08433",
        "nombre": "MALAMBO - ATLANTICO",
        "ciuu": "08433",
        "departamento": ""
    },
    {
        "idCiudad": "52435",
        "nombre": "MALLAMA - NARIÑO",
        "ciuu": "52435",
        "departamento": ""
    },
    {
        "idCiudad": "08436",
        "nombre": "MANATI - ATLANTICO",
        "ciuu": "08436",
        "departamento": ""
    },
    {
        "idCiudad": "20443",
        "nombre": "MANAURE - CESAR",
        "ciuu": "20443",
        "departamento": ""
    },
    {
        "idCiudad": "44560",
        "nombre": "MANAURE - LA GUAJIRA",
        "ciuu": "44560",
        "departamento": ""
    },
    {
        "idCiudad": "85139",
        "nombre": "MANI - CASANARE",
        "ciuu": "85139",
        "departamento": ""
    },
    {
        "idCiudad": "17001",
        "nombre": "MANIZALES - CALDAS",
        "ciuu": "17001",
        "departamento": ""
    },
    {
        "idCiudad": "25436",
        "nombre": "MANTA - CUNDINAMARCA",
        "ciuu": "25436",
        "departamento": ""
    },
    {
        "idCiudad": "17433",
        "nombre": "MANZANARES - CALDAS",
        "ciuu": "17433",
        "departamento": ""
    },
    {
        "idCiudad": "50325",
        "nombre": "MAPIRIPAN - META",
        "ciuu": "50325",
        "departamento": ""
    },
    {
        "idCiudad": "94663",
        "nombre": "MAPIRIPANA - GUAINIA",
        "ciuu": "94663",
        "departamento": ""
    },
    {
        "idCiudad": "13440",
        "nombre": "MARGARITA - BOLIVAR",
        "ciuu": "13440",
        "departamento": ""
    },
    {
        "idCiudad": "13442",
        "nombre": "MARIA LA BAJA - BOLIVAR",
        "ciuu": "13442",
        "departamento": ""
    },
    {
        "idCiudad": "05440",
        "nombre": "MARINILLA - ANTIOQUIA",
        "ciuu": "05440",
        "departamento": ""
    },
    {
        "idCiudad": "15442",
        "nombre": "MARIPI - BOYACA",
        "ciuu": "15442",
        "departamento": ""
    },
    {
        "idCiudad": "73443",
        "nombre": "MARIQUITA - TOLIMA",
        "ciuu": "73443",
        "departamento": ""
    },
    {
        "idCiudad": "17442",
        "nombre": "MARMATO - CALDAS",
        "ciuu": "17442",
        "departamento": ""
    },
    {
        "idCiudad": "17444",
        "nombre": "MARQUETALIA - CALDAS",
        "ciuu": "17444",
        "departamento": ""
    },
    {
        "idCiudad": "66440",
        "nombre": "MARSELLA - RISARALDA",
        "ciuu": "66440",
        "departamento": ""
    },
    {
        "idCiudad": "17446",
        "nombre": "MARULANDA - CALDAS",
        "ciuu": "17446",
        "departamento": ""
    },
    {
        "idCiudad": "68444",
        "nombre": "MATANZA - SANTANDER",
        "ciuu": "68444",
        "departamento": ""
    },
    {
        "idCiudad": "05001",
        "nombre": "MEDELLIN - ANTIOQUIA",
        "ciuu": "05001",
        "departamento": ""
    },
    {
        "idCiudad": "25438",
        "nombre": "MEDINA - CUNDINAMARCA",
        "ciuu": "25438",
        "departamento": ""
    },
    {
        "idCiudad": "27425",
        "nombre": "MEDIO ATRATO - CHOCO",
        "ciuu": "27425",
        "departamento": ""
    },
    {
        "idCiudad": "27430",
        "nombre": "MEDIO BAUDO - CHOCO",
        "ciuu": "27430",
        "departamento": ""
    },
    {
        "idCiudad": "27450",
        "nombre": "MEDIO SAN JUAN - CHOCO",
        "ciuu": "27450",
        "departamento": ""
    },
    {
        "idCiudad": "73449",
        "nombre": "MELGAR - TOLIMA",
        "ciuu": "73449",
        "departamento": ""
    },
    {
        "idCiudad": "19450",
        "nombre": "MERCADERES - CAUCA",
        "ciuu": "19450",
        "departamento": ""
    },
    {
        "idCiudad": "50330",
        "nombre": "MESETAS - META",
        "ciuu": "50330",
        "departamento": ""
    },
    {
        "idCiudad": "18460",
        "nombre": "MILAN - CAQUETA",
        "ciuu": "18460",
        "departamento": ""
    },
    {
        "idCiudad": "15455",
        "nombre": "MIRAFLORES - BOYACA",
        "ciuu": "15455",
        "departamento": ""
    },
    {
        "idCiudad": "95200",
        "nombre": "MIRAFLORES - GUAVIARE",
        "ciuu": "95200",
        "departamento": ""
    },
    {
        "idCiudad": "19455",
        "nombre": "MIRANDA - CAUCA",
        "ciuu": "19455",
        "departamento": ""
    },
    {
        "idCiudad": "91460",
        "nombre": "MIRITI - PARANA - AMAZONAS",
        "ciuu": "91460",
        "departamento": ""
    },
    {
        "idCiudad": "66456",
        "nombre": "MISTRATO - RISARALDA",
        "ciuu": "66456",
        "departamento": ""
    },
    {
        "idCiudad": "97001",
        "nombre": "MITU - VAUPES",
        "ciuu": "97001",
        "departamento": ""
    },
    {
        "idCiudad": "86001",
        "nombre": "MOCOA - PUTUMAYO",
        "ciuu": "86001",
        "departamento": ""
    },
    {
        "idCiudad": "68464",
        "nombre": "MOGOTES - SANTANDER",
        "ciuu": "68464",
        "departamento": ""
    },
    {
        "idCiudad": "68468",
        "nombre": "MOLAGAVITA - SANTANDER",
        "ciuu": "68468",
        "departamento": ""
    },
    {
        "idCiudad": "23464",
        "nombre": "MOMIL - CORDOBA",
        "ciuu": "23464",
        "departamento": ""
    },
    {
        "idCiudad": "13468",
        "nombre": "MOMPOS - BOLIVAR",
        "ciuu": "13468",
        "departamento": ""
    },
    {
        "idCiudad": "15464",
        "nombre": "MONGUA - BOYACA",
        "ciuu": "15464",
        "departamento": ""
    },
    {
        "idCiudad": "15466",
        "nombre": "MONGUI - BOYACA",
        "ciuu": "15466",
        "departamento": ""
    },
    {
        "idCiudad": "15469",
        "nombre": "MONIQUIRA - BOYACA",
        "ciuu": "15469",
        "departamento": ""
    },
    {
        "idCiudad": "05467",
        "nombre": "MONTEBELLO - ANTIOQUIA",
        "ciuu": "05467",
        "departamento": ""
    },
    {
        "idCiudad": "13458",
        "nombre": "MONTECRISTO - BOLIVAR",
        "ciuu": "13458",
        "departamento": ""
    },
    {
        "idCiudad": "23466",
        "nombre": "MONTELIBANO - CORDOBA",
        "ciuu": "23466",
        "departamento": ""
    },
    {
        "idCiudad": "63470",
        "nombre": "MONTENEGRO - QUINDIO",
        "ciuu": "63470",
        "departamento": ""
    },
    {
        "idCiudad": "23001",
        "nombre": "MONTERIA - CORDOBA",
        "ciuu": "23001",
        "departamento": ""
    },
    {
        "idCiudad": "85162",
        "nombre": "MONTERREY - CASANARE",
        "ciuu": "85162",
        "departamento": ""
    },
    {
        "idCiudad": "23500",
        "nombre": "MOÑITOS - CORDOBA",
        "ciuu": "23500",
        "departamento": ""
    },
    {
        "idCiudad": "13473",
        "nombre": "MORALES - BOLIVAR",
        "ciuu": "13473",
        "departamento": ""
    },
    {
        "idCiudad": "19473",
        "nombre": "MORALES - CAUCA",
        "ciuu": "19473",
        "departamento": ""
    },
    {
        "idCiudad": "18479",
        "nombre": "MORELIA - CAQUETA",
        "ciuu": "18479",
        "departamento": ""
    },
    {
        "idCiudad": "94888",
        "nombre": "MORICHAL - GUAINIA",
        "ciuu": "94888",
        "departamento": ""
    },
    {
        "idCiudad": "70473",
        "nombre": "MORROA - SUCRE",
        "ciuu": "70473",
        "departamento": ""
    },
    {
        "idCiudad": "25473",
        "nombre": "MOSQUERA - CUNDINAMARCA",
        "ciuu": "25473",
        "departamento": ""
    },
    {
        "idCiudad": "52473",
        "nombre": "MOSQUERA - NARIÑO",
        "ciuu": "52473",
        "departamento": ""
    },
    {
        "idCiudad": "15476",
        "nombre": "MOTAVITA - BOYACA",
        "ciuu": "15476",
        "departamento": ""
    },
    {
        "idCiudad": "73461",
        "nombre": "MURILLO - TOLIMA",
        "ciuu": "73461",
        "departamento": ""
    },
    {
        "idCiudad": "05475",
        "nombre": "MURINDO - ANTIOQUIA",
        "ciuu": "05475",
        "departamento": ""
    },
    {
        "idCiudad": "05480",
        "nombre": "MUTATA - ANTIOQUIA",
        "ciuu": "05480",
        "departamento": ""
    },
    {
        "idCiudad": "54480",
        "nombre": "MUTISCUA - N. DE SANTANDER",
        "ciuu": "54480",
        "departamento": ""
    },
    {
        "idCiudad": "15480",
        "nombre": "MUZO - BOYACA",
        "ciuu": "15480",
        "departamento": ""
    },
    {
        "idCiudad": "05483",
        "nombre": "NARIÑO - ANTIOQUIA",
        "ciuu": "05483",
        "departamento": ""
    },
    {
        "idCiudad": "25483",
        "nombre": "NARIÑO - CUNDINAMARCA",
        "ciuu": "25483",
        "departamento": ""
    },
    {
        "idCiudad": "52480",
        "nombre": "NARIÑO - NARIÑO",
        "ciuu": "52480",
        "departamento": ""
    },
    {
        "idCiudad": "41483",
        "nombre": "NATAGA - HUILA",
        "ciuu": "41483",
        "departamento": ""
    },
    {
        "idCiudad": "73483",
        "nombre": "NATAGAIMA - TOLIMA",
        "ciuu": "73483",
        "departamento": ""
    },
    {
        "idCiudad": "05495",
        "nombre": "NECHI - ANTIOQUIA",
        "ciuu": "05495",
        "departamento": ""
    },
    {
        "idCiudad": "05490",
        "nombre": "NECOCLI - ANTIOQUIA",
        "ciuu": "05490",
        "departamento": ""
    },
    {
        "idCiudad": "17486",
        "nombre": "NEIRA - CALDAS",
        "ciuu": "17486",
        "departamento": ""
    },
    {
        "idCiudad": "41001",
        "nombre": "NEIVA - HUILA",
        "ciuu": "41001",
        "departamento": ""
    },
    {
        "idCiudad": "25486",
        "nombre": "NEMOCON - CUNDINAMARCA",
        "ciuu": "25486",
        "departamento": ""
    },
    {
        "idCiudad": "25488",
        "nombre": "NILO - CUNDINAMARCA",
        "ciuu": "25488",
        "departamento": ""
    },
    {
        "idCiudad": "25489",
        "nombre": "NIMAIMA - CUNDINAMARCA",
        "ciuu": "25489",
        "departamento": ""
    },
    {
        "idCiudad": "15491",
        "nombre": "NOBSA - BOYACA",
        "ciuu": "15491",
        "departamento": ""
    },
    {
        "idCiudad": "25491",
        "nombre": "NOCAIMA - CUNDINAMARCA",
        "ciuu": "25491",
        "departamento": ""
    },
    {
        "idCiudad": "17495",
        "nombre": "NORCASIA - CALDAS",
        "ciuu": "17495",
        "departamento": ""
    },
    {
        "idCiudad": "13490",
        "nombre": "NOROSI - BOLIVAR",
        "ciuu": "13490",
        "departamento": ""
    },
    {
        "idCiudad": "27491",
        "nombre": "NOVITA - CHOCO",
        "ciuu": "27491",
        "departamento": ""
    },
    {
        "idCiudad": "47460",
        "nombre": "NUEVA GRANADA - MAGDALENA",
        "ciuu": "47460",
        "departamento": ""
    },
    {
        "idCiudad": "15494",
        "nombre": "NUEVO COLON - BOYACA",
        "ciuu": "15494",
        "departamento": ""
    },
    {
        "idCiudad": "85225",
        "nombre": "NUNCHIA - CASANARE",
        "ciuu": "85225",
        "departamento": ""
    },
    {
        "idCiudad": "27495",
        "nombre": "NUQUI - CHOCO",
        "ciuu": "27495",
        "departamento": ""
    },
    {
        "idCiudad": "76497",
        "nombre": "OBANDO - VALLE DEL CAUCA",
        "ciuu": "76497",
        "departamento": ""
    },
    {
        "idCiudad": "68498",
        "nombre": "OCAMONTE - SANTANDER",
        "ciuu": "68498",
        "departamento": ""
    },
    {
        "idCiudad": "54498",
        "nombre": "OCAÑA - N. DE SANTANDER",
        "ciuu": "54498",
        "departamento": ""
    },
    {
        "idCiudad": "68500",
        "nombre": "OIBA - SANTANDER",
        "ciuu": "68500",
        "departamento": ""
    },
    {
        "idCiudad": "15500",
        "nombre": "OICATA - BOYACA",
        "ciuu": "15500",
        "departamento": ""
    },
    {
        "idCiudad": "05501",
        "nombre": "OLAYA - ANTIOQUIA",
        "ciuu": "05501",
        "departamento": ""
    },
    {
        "idCiudad": "52490",
        "nombre": "OLAYA HERRERA - NARIÑO",
        "ciuu": "52490",
        "departamento": ""
    },
    {
        "idCiudad": "68502",
        "nombre": "ONZAGA - SANTANDER",
        "ciuu": "68502",
        "departamento": ""
    },
    {
        "idCiudad": "41503",
        "nombre": "OPORAPA - HUILA",
        "ciuu": "41503",
        "departamento": ""
    },
    {
        "idCiudad": "86320",
        "nombre": "ORITO - PUTUMAYO",
        "ciuu": "86320",
        "departamento": ""
    },
    {
        "idCiudad": "85230",
        "nombre": "OROCUE - CASANARE",
        "ciuu": "85230",
        "departamento": ""
    },
    {
        "idCiudad": "73504",
        "nombre": "ORTEGA - TOLIMA",
        "ciuu": "73504",
        "departamento": ""
    },
    {
        "idCiudad": "52506",
        "nombre": "OSPINA - NARIÑO",
        "ciuu": "52506",
        "departamento": ""
    },
    {
        "idCiudad": "15507",
        "nombre": "OTANCHE - BOYACA",
        "ciuu": "15507",
        "departamento": ""
    },
    {
        "idCiudad": "70508",
        "nombre": "OVEJAS - SUCRE",
        "ciuu": "70508",
        "departamento": ""
    },
    {
        "idCiudad": "15511",
        "nombre": "PACHAVITA - BOYACA",
        "ciuu": "15511",
        "departamento": ""
    },
    {
        "idCiudad": "25513",
        "nombre": "PACHO - CUNDINAMARCA",
        "ciuu": "25513",
        "departamento": ""
    },
    {
        "idCiudad": "97511",
        "nombre": "PACOA - VAUPES",
        "ciuu": "97511",
        "departamento": ""
    },
    {
        "idCiudad": "17513",
        "nombre": "PACORA - CALDAS",
        "ciuu": "17513",
        "departamento": ""
    },
    {
        "idCiudad": "19513",
        "nombre": "PADILLA - CAUCA",
        "ciuu": "19513",
        "departamento": ""
    },
    {
        "idCiudad": "15514",
        "nombre": "PAEZ - BOYACA",
        "ciuu": "15514",
        "departamento": ""
    },
    {
        "idCiudad": "19517",
        "nombre": "PAEZ - CAUCA",
        "ciuu": "19517",
        "departamento": ""
    },
    {
        "idCiudad": "41518",
        "nombre": "PAICOL - HUILA",
        "ciuu": "41518",
        "departamento": ""
    },
    {
        "idCiudad": "20517",
        "nombre": "PAILITAS - CESAR",
        "ciuu": "20517",
        "departamento": ""
    },
    {
        "idCiudad": "25518",
        "nombre": "PAIME - CUNDINAMARCA",
        "ciuu": "25518",
        "departamento": ""
    },
    {
        "idCiudad": "15516",
        "nombre": "PAIPA - BOYACA",
        "ciuu": "15516",
        "departamento": ""
    },
    {
        "idCiudad": "15518",
        "nombre": "PAJARITO - BOYACA",
        "ciuu": "15518",
        "departamento": ""
    },
    {
        "idCiudad": "41524",
        "nombre": "PALERMO - HUILA",
        "ciuu": "41524",
        "departamento": ""
    },
    {
        "idCiudad": "17524",
        "nombre": "PALESTINA - CALDAS",
        "ciuu": "17524",
        "departamento": ""
    },
    {
        "idCiudad": "41530",
        "nombre": "PALESTINA - HUILA",
        "ciuu": "41530",
        "departamento": ""
    },
    {
        "idCiudad": "68522",
        "nombre": "PALMAR - SANTANDER",
        "ciuu": "68522",
        "departamento": ""
    },
    {
        "idCiudad": "08520",
        "nombre": "PALMAR DE VARELA - ATLANTICO",
        "ciuu": "08520",
        "departamento": ""
    },
    {
        "idCiudad": "68524",
        "nombre": "PALMAS DEL SOCORRO - SANTANDER",
        "ciuu": "68524",
        "departamento": ""
    },
    {
        "idCiudad": "76520",
        "nombre": "PALMIRA - VALLE DEL CAUCA",
        "ciuu": "76520",
        "departamento": ""
    },
    {
        "idCiudad": "70523",
        "nombre": "PALMITO - SUCRE",
        "ciuu": "70523",
        "departamento": ""
    },
    {
        "idCiudad": "73520",
        "nombre": "PALOCABILDO - TOLIMA",
        "ciuu": "73520",
        "departamento": ""
    },
    {
        "idCiudad": "54518",
        "nombre": "PAMPLONA - N. DE SANTANDER",
        "ciuu": "54518",
        "departamento": ""
    },
    {
        "idCiudad": "54520",
        "nombre": "PAMPLONITA - N. DE SANTANDER",
        "ciuu": "54520",
        "departamento": ""
    },
    {
        "idCiudad": "94887",
        "nombre": "PANA PANA - GUAINIA",
        "ciuu": "94887",
        "departamento": ""
    },
    {
        "idCiudad": "25524",
        "nombre": "PANDI - CUNDINAMARCA",
        "ciuu": "25524",
        "departamento": ""
    },
    {
        "idCiudad": "15522",
        "nombre": "PANQUEBA - BOYACA",
        "ciuu": "15522",
        "departamento": ""
    },
    {
        "idCiudad": "97777",
        "nombre": "PAPUNAUA - VAUPES",
        "ciuu": "97777",
        "departamento": ""
    },
    {
        "idCiudad": "68533",
        "nombre": "PARAMO - SANTANDER",
        "ciuu": "68533",
        "departamento": ""
    },
    {
        "idCiudad": "25530",
        "nombre": "PARATEBUENO - CUNDINAMARCA",
        "ciuu": "25530",
        "departamento": ""
    },
    {
        "idCiudad": "25535",
        "nombre": "PASCA - CUNDINAMARCA",
        "ciuu": "25535",
        "departamento": ""
    },
    {
        "idCiudad": "52001",
        "nombre": "PASTO - NARIÑO",
        "ciuu": "52001",
        "departamento": ""
    },
    {
        "idCiudad": "19532",
        "nombre": "PATIA - CAUCA",
        "ciuu": "19532",
        "departamento": ""
    },
    {
        "idCiudad": "15531",
        "nombre": "PAUNA - BOYACA",
        "ciuu": "15531",
        "departamento": ""
    },
    {
        "idCiudad": "15533",
        "nombre": "PAYA - BOYACA",
        "ciuu": "15533",
        "departamento": ""
    },
    {
        "idCiudad": "85250",
        "nombre": "PAZ DE ARIPORO - CASANARE",
        "ciuu": "85250",
        "departamento": ""
    },
    {
        "idCiudad": "15537",
        "nombre": "PAZ DE RIO - BOYACA",
        "ciuu": "15537",
        "departamento": ""
    },
    {
        "idCiudad": "05541",
        "nombre": "PEÐOL - ANTIOQUIA",
        "ciuu": "05541",
        "departamento": ""
    },
    {
        "idCiudad": "47541",
        "nombre": "PEDRAZA - MAGDALENA",
        "ciuu": "47541",
        "departamento": ""
    },
    {
        "idCiudad": "20550",
        "nombre": "PELAYA - CESAR",
        "ciuu": "20550",
        "departamento": ""
    },
    {
        "idCiudad": "17541",
        "nombre": "PENSILVANIA - CALDAS",
        "ciuu": "17541",
        "departamento": ""
    },
    {
        "idCiudad": "05543",
        "nombre": "PEQUE - ANTIOQUIA",
        "ciuu": "05543",
        "departamento": ""
    },
    {
        "idCiudad": "66001",
        "nombre": "PEREIRA - RISARALDA",
        "ciuu": "66001",
        "departamento": ""
    },
    {
        "idCiudad": "15542",
        "nombre": "PESCA - BOYACA",
        "ciuu": "15542",
        "departamento": ""
    },
    {
        "idCiudad": "19533",
        "nombre": "PIAMONTE - CAUCA",
        "ciuu": "19533",
        "departamento": ""
    },
    {
        "idCiudad": "68547",
        "nombre": "PIEDECUESTA - SANTANDER",
        "ciuu": "68547",
        "departamento": ""
    },
    {
        "idCiudad": "73547",
        "nombre": "PIEDRAS - TOLIMA",
        "ciuu": "73547",
        "departamento": ""
    },
    {
        "idCiudad": "19548",
        "nombre": "PIENDAMO - CAUCA",
        "ciuu": "19548",
        "departamento": ""
    },
    {
        "idCiudad": "63548",
        "nombre": "PIJAO - QUINDIO",
        "ciuu": "63548",
        "departamento": ""
    },
    {
        "idCiudad": "47545",
        "nombre": "PIJIÑO DEL CARMEN - MAGDALENA",
        "ciuu": "47545",
        "departamento": ""
    },
    {
        "idCiudad": "68549",
        "nombre": "PINCHOTE - SANTANDER",
        "ciuu": "68549",
        "departamento": ""
    },
    {
        "idCiudad": "13549",
        "nombre": "PINILLOS - BOLIVAR",
        "ciuu": "13549",
        "departamento": ""
    },
    {
        "idCiudad": "08549",
        "nombre": "PIOJO - ATLANTICO",
        "ciuu": "08549",
        "departamento": ""
    },
    {
        "idCiudad": "15550",
        "nombre": "PISBA - BOYACA",
        "ciuu": "15550",
        "departamento": ""
    },
    {
        "idCiudad": "41548",
        "nombre": "PITAL - HUILA",
        "ciuu": "41548",
        "departamento": ""
    },
    {
        "idCiudad": "41551",
        "nombre": "PITALITO - HUILA",
        "ciuu": "41551",
        "departamento": ""
    },
    {
        "idCiudad": "47551",
        "nombre": "PIVIJAY - MAGDALENA",
        "ciuu": "47551",
        "departamento": ""
    },
    {
        "idCiudad": "73555",
        "nombre": "PLANADAS - TOLIMA",
        "ciuu": "73555",
        "departamento": ""
    },
    {
        "idCiudad": "23555",
        "nombre": "PLANETA RICA - CORDOBA",
        "ciuu": "23555",
        "departamento": ""
    },
    {
        "idCiudad": "47555",
        "nombre": "PLATO - MAGDALENA",
        "ciuu": "47555",
        "departamento": ""
    },
    {
        "idCiudad": "52540",
        "nombre": "POLICARPA - NARIÑO",
        "ciuu": "52540",
        "departamento": ""
    },
    {
        "idCiudad": "08558",
        "nombre": "POLONUEVO - ATLANTICO",
        "ciuu": "08558",
        "departamento": ""
    },
    {
        "idCiudad": "08560",
        "nombre": "PONEDERA - ATLANTICO",
        "ciuu": "08560",
        "departamento": ""
    },
    {
        "idCiudad": "19001",
        "nombre": "POPAYAN - CAUCA",
        "ciuu": "19001",
        "departamento": ""
    },
    {
        "idCiudad": "85263",
        "nombre": "PORE - CASANARE",
        "ciuu": "85263",
        "departamento": ""
    },
    {
        "idCiudad": "52560",
        "nombre": "POTOSI - NARIÑO",
        "ciuu": "52560",
        "departamento": ""
    },
    {
        "idCiudad": "76563",
        "nombre": "PRADERA - VALLE DEL CAUCA",
        "ciuu": "76563",
        "departamento": ""
    },
    {
        "idCiudad": "73563",
        "nombre": "PRADO - TOLIMA",
        "ciuu": "73563",
        "departamento": ""
    },
    {
        "idCiudad": "52565",
        "nombre": "PROVIDENCIA - NARIÑO",
        "ciuu": "52565",
        "departamento": ""
    },
    {
        "idCiudad": "88564",
        "nombre": "PROVIDENCIA - SAN ANDRES",
        "ciuu": "88564",
        "departamento": ""
    },
    {
        "idCiudad": "20570",
        "nombre": "PUEBLO BELLO - CESAR",
        "ciuu": "20570",
        "departamento": ""
    },
    {
        "idCiudad": "23570",
        "nombre": "PUEBLO NUEVO - CORDOBA",
        "ciuu": "23570",
        "departamento": ""
    },
    {
        "idCiudad": "66572",
        "nombre": "PUEBLO RICO - RISARALDA",
        "ciuu": "66572",
        "departamento": ""
    },
    {
        "idCiudad": "05576",
        "nombre": "PUEBLORRICO - ANTIOQUIA",
        "ciuu": "05576",
        "departamento": ""
    },
    {
        "idCiudad": "47570",
        "nombre": "PUEBLOVIEJO - MAGDALENA",
        "ciuu": "47570",
        "departamento": ""
    },
    {
        "idCiudad": "68572",
        "nombre": "PUENTE NACIONAL - SANTANDER",
        "ciuu": "68572",
        "departamento": ""
    },
    {
        "idCiudad": "52573",
        "nombre": "PUERRES - NARIÑO",
        "ciuu": "52573",
        "departamento": ""
    },
    {
        "idCiudad": "91530",
        "nombre": "PUERTO ALEGRIA - AMAZONAS",
        "ciuu": "91530",
        "departamento": ""
    },
    {
        "idCiudad": "91536",
        "nombre": "PUERTO ARICA - AMAZONAS",
        "ciuu": "91536",
        "departamento": ""
    },
    {
        "idCiudad": "86568",
        "nombre": "PUERTO ASIS - PUTUMAYO",
        "ciuu": "86568",
        "departamento": ""
    },
    {
        "idCiudad": "05579",
        "nombre": "PUERTO BERRIO - ANTIOQUIA",
        "ciuu": "05579",
        "departamento": ""
    },
    {
        "idCiudad": "15572",
        "nombre": "PUERTO BOYACA - BOYACA",
        "ciuu": "15572",
        "departamento": ""
    },
    {
        "idCiudad": "86569",
        "nombre": "PUERTO CAICEDO - PUTUMAYO",
        "ciuu": "86569",
        "departamento": ""
    },
    {
        "idCiudad": "99001",
        "nombre": "PUERTO CARREÑO - VICHADA",
        "ciuu": "99001",
        "departamento": ""
    },
    {
        "idCiudad": "08573",
        "nombre": "PUERTO COLOMBIA - ATLANTICO",
        "ciuu": "08573",
        "departamento": ""
    },
    {
        "idCiudad": "94884",
        "nombre": "PUERTO COLOMBIA - GUAINIA",
        "ciuu": "94884",
        "departamento": ""
    },
    {
        "idCiudad": "50450",
        "nombre": "PUERTO CONCORDIA - META",
        "ciuu": "50450",
        "departamento": ""
    },
    {
        "idCiudad": "23574",
        "nombre": "PUERTO ESCONDIDO - CORDOBA",
        "ciuu": "23574",
        "departamento": ""
    },
    {
        "idCiudad": "50568",
        "nombre": "PUERTO GAITAN - META",
        "ciuu": "50568",
        "departamento": ""
    },
    {
        "idCiudad": "86571",
        "nombre": "PUERTO GUZMAN - PUTUMAYO",
        "ciuu": "86571",
        "departamento": ""
    },
    {
        "idCiudad": "23580",
        "nombre": "PUERTO LIBERTADOR - CORDOBA",
        "ciuu": "23580",
        "departamento": ""
    },
    {
        "idCiudad": "50577",
        "nombre": "PUERTO LLERAS - META",
        "ciuu": "50577",
        "departamento": ""
    },
    {
        "idCiudad": "50573",
        "nombre": "PUERTO LOPEZ - META",
        "ciuu": "50573",
        "departamento": ""
    },
    {
        "idCiudad": "05585",
        "nombre": "PUERTO NARE - ANTIOQUIA",
        "ciuu": "05585",
        "departamento": ""
    },
    {
        "idCiudad": "91540",
        "nombre": "PUERTO NARIÑO - AMAZONAS",
        "ciuu": "91540",
        "departamento": ""
    },
    {
        "idCiudad": "68573",
        "nombre": "PUERTO PARRA - SANTANDER",
        "ciuu": "68573",
        "departamento": ""
    },
    {
        "idCiudad": "18592",
        "nombre": "PUERTO RICO - CAQUETA",
        "ciuu": "18592",
        "departamento": ""
    },
    {
        "idCiudad": "50590",
        "nombre": "PUERTO RICO - META",
        "ciuu": "50590",
        "departamento": ""
    },
    {
        "idCiudad": "81591",
        "nombre": "PUERTO RONDON - ARAUCA",
        "ciuu": "81591",
        "departamento": ""
    },
    {
        "idCiudad": "25572",
        "nombre": "PUERTO SALGAR - CUNDINAMARCA",
        "ciuu": "25572",
        "departamento": ""
    },
    {
        "idCiudad": "91669",
        "nombre": "PUERTO SANTANDER - AMAZONAS",
        "ciuu": "91669",
        "departamento": ""
    },
    {
        "idCiudad": "54553",
        "nombre": "PUERTO SANTANDER - N. DE SANTA",
        "ciuu": "54553",
        "departamento": ""
    },
    {
        "idCiudad": "19573",
        "nombre": "PUERTO TEJADA - CAUCA",
        "ciuu": "19573",
        "departamento": ""
    },
    {
        "idCiudad": "05591",
        "nombre": "PUERTO TRIUNFO - ANTIOQUIA",
        "ciuu": "05591",
        "departamento": ""
    },
    {
        "idCiudad": "68575",
        "nombre": "PUERTO WILCHES - SANTANDER",
        "ciuu": "68575",
        "departamento": ""
    },
    {
        "idCiudad": "25580",
        "nombre": "PULI - CUNDINAMARCA",
        "ciuu": "25580",
        "departamento": ""
    },
    {
        "idCiudad": "52585",
        "nombre": "PUPIALES - NARIÑO",
        "ciuu": "52585",
        "departamento": ""
    },
    {
        "idCiudad": "19585",
        "nombre": "PURACE - CAUCA",
        "ciuu": "19585",
        "departamento": ""
    },
    {
        "idCiudad": "73585",
        "nombre": "PURIFICACION - TOLIMA",
        "ciuu": "73585",
        "departamento": ""
    },
    {
        "idCiudad": "23586",
        "nombre": "PURISIMA - CORDOBA",
        "ciuu": "23586",
        "departamento": ""
    },
    {
        "idCiudad": "25592",
        "nombre": "QUEBRADANEGRA - CUNDINAMARCA",
        "ciuu": "25592",
        "departamento": ""
    },
    {
        "idCiudad": "25594",
        "nombre": "QUETAME - CUNDINAMARCA",
        "ciuu": "25594",
        "departamento": ""
    },
    {
        "idCiudad": "27001",
        "nombre": "QUIBDO - CHOCO",
        "ciuu": "27001",
        "departamento": ""
    },
    {
        "idCiudad": "63594",
        "nombre": "QUIMBAYA - QUINDIO",
        "ciuu": "63594",
        "departamento": ""
    },
    {
        "idCiudad": "66594",
        "nombre": "QUINCHIA - RISARALDA",
        "ciuu": "66594",
        "departamento": ""
    },
    {
        "idCiudad": "15580",
        "nombre": "QUIPAMA - BOYACA",
        "ciuu": "15580",
        "departamento": ""
    },
    {
        "idCiudad": "25596",
        "nombre": "QUIPILE - CUNDINAMARCA",
        "ciuu": "25596",
        "departamento": ""
    },
    {
        "idCiudad": "54599",
        "nombre": "RAGONVALIA - N. DE SANTANDER",
        "ciuu": "54599",
        "departamento": ""
    },
    {
        "idCiudad": "15599",
        "nombre": "RAMIRIQUI - BOYACA",
        "ciuu": "15599",
        "departamento": ""
    },
    {
        "idCiudad": "15600",
        "nombre": "RAQUIRA - BOYACA",
        "ciuu": "15600",
        "departamento": ""
    },
    {
        "idCiudad": "85279",
        "nombre": "RECETOR - CASANARE",
        "ciuu": "85279",
        "departamento": ""
    },
    {
        "idCiudad": "13580",
        "nombre": "REGIDOR - BOLIVAR",
        "ciuu": "13580",
        "departamento": ""
    },
    {
        "idCiudad": "05604",
        "nombre": "REMEDIOS - ANTIOQUIA",
        "ciuu": "05604",
        "departamento": ""
    },
    {
        "idCiudad": "47605",
        "nombre": "REMOLINO - MAGDALENA",
        "ciuu": "47605",
        "departamento": ""
    },
    {
        "idCiudad": "08606",
        "nombre": "REPELON - ATLANTICO",
        "ciuu": "08606",
        "departamento": ""
    },
    {
        "idCiudad": "50606",
        "nombre": "RESTREPO - META",
        "ciuu": "50606",
        "departamento": ""
    },
    {
        "idCiudad": "76606",
        "nombre": "RESTREPO - VALLE DEL CAUCA",
        "ciuu": "76606",
        "departamento": ""
    },
    {
        "idCiudad": "05607",
        "nombre": "RETIRO - ANTIOQUIA",
        "ciuu": "05607",
        "departamento": ""
    },
    {
        "idCiudad": "25612",
        "nombre": "RICAURTE - CUNDINAMARCA",
        "ciuu": "25612",
        "departamento": ""
    },
    {
        "idCiudad": "52612",
        "nombre": "RICAURTE - NARIÑO",
        "ciuu": "52612",
        "departamento": ""
    },
    {
        "idCiudad": "20614",
        "nombre": "RIO DE ORO - CESAR",
        "ciuu": "20614",
        "departamento": ""
    },
    {
        "idCiudad": "27580",
        "nombre": "RIO IRO - CHOCO",
        "ciuu": "27580",
        "departamento": ""
    },
    {
        "idCiudad": "27600",
        "nombre": "RIO QUITO - CHOCO",
        "ciuu": "27600",
        "departamento": ""
    },
    {
        "idCiudad": "13600",
        "nombre": "RIO VIEJO - BOLIVAR",
        "ciuu": "13600",
        "departamento": ""
    },
    {
        "idCiudad": "73616",
        "nombre": "RIOBLANCO - TOLIMA",
        "ciuu": "73616",
        "departamento": ""
    },
    {
        "idCiudad": "76616",
        "nombre": "RIOFRIO - VALLE DEL CAUCA",
        "ciuu": "76616",
        "departamento": ""
    },
    {
        "idCiudad": "44001",
        "nombre": "RIOHACHA - LA GUAJIRA",
        "ciuu": "44001",
        "departamento": ""
    },
    {
        "idCiudad": "05615",
        "nombre": "RIONEGRO - ANTIOQUIA",
        "ciuu": "05615",
        "departamento": ""
    },
    {
        "idCiudad": "68615",
        "nombre": "RIONEGRO - SANTANDER",
        "ciuu": "68615",
        "departamento": ""
    },
    {
        "idCiudad": "17614",
        "nombre": "RIOSUCIO - CALDAS",
        "ciuu": "17614",
        "departamento": ""
    },
    {
        "idCiudad": "27615",
        "nombre": "RIOSUCIO - CHOCO",
        "ciuu": "27615",
        "departamento": ""
    },
    {
        "idCiudad": "17616",
        "nombre": "RISARALDA - CALDAS",
        "ciuu": "17616",
        "departamento": ""
    },
    {
        "idCiudad": "41615",
        "nombre": "RIVERA - HUILA",
        "ciuu": "41615",
        "departamento": ""
    },
    {
        "idCiudad": "52621",
        "nombre": "ROBERTO PAYAN - NARIÑO",
        "ciuu": "52621",
        "departamento": ""
    },
    {
        "idCiudad": "76622",
        "nombre": "ROLDANILLO - VALLE DEL CAUCA",
        "ciuu": "76622",
        "departamento": ""
    },
    {
        "idCiudad": "73622",
        "nombre": "RONCESVALLES - TOLIMA",
        "ciuu": "73622",
        "departamento": ""
    },
    {
        "idCiudad": "15621",
        "nombre": "RONDON - BOYACA",
        "ciuu": "15621",
        "departamento": ""
    },
    {
        "idCiudad": "19622",
        "nombre": "ROSAS - CAUCA",
        "ciuu": "19622",
        "departamento": ""
    },
    {
        "idCiudad": "73624",
        "nombre": "ROVIRA - TOLIMA",
        "ciuu": "73624",
        "departamento": ""
    },
    {
        "idCiudad": "68655",
        "nombre": "SABANA DE TORRES - SANTANDER",
        "ciuu": "68655",
        "departamento": ""
    },
    {
        "idCiudad": "08634",
        "nombre": "SABANAGRANDE - ATLANTICO",
        "ciuu": "08634",
        "departamento": ""
    },
    {
        "idCiudad": "05628",
        "nombre": "SABANALARGA - ANTIOQUIA",
        "ciuu": "05628",
        "departamento": ""
    },
    {
        "idCiudad": "08638",
        "nombre": "SABANALARGA - ATLANTICO",
        "ciuu": "08638",
        "departamento": ""
    },
    {
        "idCiudad": "85300",
        "nombre": "SABANALARGA - CASANARE",
        "ciuu": "85300",
        "departamento": ""
    },
    {
        "idCiudad": "47660",
        "nombre": "SABANAS DE SAN ANGEL - MAGDALE",
        "ciuu": "47660",
        "departamento": ""
    },
    {
        "idCiudad": "05631",
        "nombre": "SABANETA - ANTIOQUIA",
        "ciuu": "05631",
        "departamento": ""
    },
    {
        "idCiudad": "15632",
        "nombre": "SABOYA - BOYACA",
        "ciuu": "15632",
        "departamento": ""
    },
    {
        "idCiudad": "85315",
        "nombre": "SACAMA - CASANARE",
        "ciuu": "85315",
        "departamento": ""
    },
    {
        "idCiudad": "15638",
        "nombre": "SACHICA - BOYACA",
        "ciuu": "15638",
        "departamento": ""
    },
    {
        "idCiudad": "23660",
        "nombre": "SAHAGUN - CORDOBA",
        "ciuu": "23660",
        "departamento": ""
    },
    {
        "idCiudad": "41660",
        "nombre": "SALADOBLANCO - HUILA",
        "ciuu": "41660",
        "departamento": ""
    },
    {
        "idCiudad": "17653",
        "nombre": "SALAMINA - CALDAS",
        "ciuu": "17653",
        "departamento": ""
    },
    {
        "idCiudad": "47675",
        "nombre": "SALAMINA - MAGDALENA",
        "ciuu": "47675",
        "departamento": ""
    },
    {
        "idCiudad": "54660",
        "nombre": "SALAZAR - N. DE SANTANDER",
        "ciuu": "54660",
        "departamento": ""
    },
    {
        "idCiudad": "73671",
        "nombre": "SALDAÑA - TOLIMA",
        "ciuu": "73671",
        "departamento": ""
    },
    {
        "idCiudad": "63690",
        "nombre": "SALENTO - QUINDIO",
        "ciuu": "63690",
        "departamento": ""
    },
    {
        "idCiudad": "05642",
        "nombre": "SALGAR - ANTIOQUIA",
        "ciuu": "05642",
        "departamento": ""
    },
    {
        "idCiudad": "15646",
        "nombre": "SAMACA - BOYACA",
        "ciuu": "15646",
        "departamento": ""
    },
    {
        "idCiudad": "17662",
        "nombre": "SAMANA - CALDAS",
        "ciuu": "17662",
        "departamento": ""
    },
    {
        "idCiudad": "52678",
        "nombre": "SAMANIEGO - NARIÑO",
        "ciuu": "52678",
        "departamento": ""
    },
    {
        "idCiudad": "70670",
        "nombre": "SAMPUES - SUCRE",
        "ciuu": "70670",
        "departamento": ""
    },
    {
        "idCiudad": "41668",
        "nombre": "SAN AGUSTIN - HUILA",
        "ciuu": "41668",
        "departamento": ""
    },
    {
        "idCiudad": "20710",
        "nombre": "SAN ALBERTO - CESAR",
        "ciuu": "20710",
        "departamento": ""
    },
    {
        "idCiudad": "88001",
        "nombre": "SAN ANDRES - SAN ANDRES",
        "ciuu": "88001",
        "departamento": ""
    },
    {
        "idCiudad": "68669",
        "nombre": "SAN ANDRES - SANTANDER",
        "ciuu": "68669",
        "departamento": ""
    },
    {
        "idCiudad": "05647",
        "nombre": "SAN ANDRES DE CUERQUIA - ANTIO",
        "ciuu": "05647",
        "departamento": ""
    },
    {
        "idCiudad": "52835",
        "nombre": "SAN ANDRES DE TUMACO - NARIÑO",
        "ciuu": "52835",
        "departamento": ""
    },
    {
        "idCiudad": "23670",
        "nombre": "SAN ANDRES SOTAVENTO - CORDOBA",
        "ciuu": "23670",
        "departamento": ""
    },
    {
        "idCiudad": "23672",
        "nombre": "SAN ANTERO - CORDOBA",
        "ciuu": "23672",
        "departamento": ""
    },
    {
        "idCiudad": "73675",
        "nombre": "SAN ANTONIO - TOLIMA",
        "ciuu": "73675",
        "departamento": ""
    },
    {
        "idCiudad": "25645",
        "nombre": "SAN ANTONIO DEL TEQUENDAMA - C",
        "ciuu": "25645",
        "departamento": ""
    },
    {
        "idCiudad": "68673",
        "nombre": "SAN BENITO - SANTANDER",
        "ciuu": "68673",
        "departamento": ""
    },
    {
        "idCiudad": "70678",
        "nombre": "SAN BENITO ABAD - SUCRE",
        "ciuu": "70678",
        "departamento": ""
    },
    {
        "idCiudad": "25649",
        "nombre": "SAN BERNARDO - CUNDINAMARCA",
        "ciuu": "25649",
        "departamento": ""
    },
    {
        "idCiudad": "52685",
        "nombre": "SAN BERNARDO - NARIÑO",
        "ciuu": "52685",
        "departamento": ""
    },
    {
        "idCiudad": "23675",
        "nombre": "SAN BERNARDO DEL VIENTO - CORD",
        "ciuu": "23675",
        "departamento": ""
    },
    {
        "idCiudad": "54670",
        "nombre": "SAN CALIXTO - N. DE SANTANDER",
        "ciuu": "54670",
        "departamento": ""
    },
    {
        "idCiudad": "05649",
        "nombre": "SAN CARLOS - ANTIOQUIA",
        "ciuu": "05649",
        "departamento": ""
    },
    {
        "idCiudad": "23678",
        "nombre": "SAN CARLOS - CORDOBA",
        "ciuu": "23678",
        "departamento": ""
    },
    {
        "idCiudad": "50680",
        "nombre": "SAN CARLOS DE GUAROA - META",
        "ciuu": "50680",
        "departamento": ""
    },
    {
        "idCiudad": "25653",
        "nombre": "SAN CAYETANO - CUNDINAMARCA",
        "ciuu": "25653",
        "departamento": ""
    },
    {
        "idCiudad": "54673",
        "nombre": "SAN CAYETANO - N. DE SANTANDER",
        "ciuu": "54673",
        "departamento": ""
    },
    {
        "idCiudad": "13620",
        "nombre": "SAN CRISTOBAL - BOLIVAR",
        "ciuu": "13620",
        "departamento": ""
    },
    {
        "idCiudad": "20750",
        "nombre": "SAN DIEGO - CESAR",
        "ciuu": "20750",
        "departamento": ""
    },
    {
        "idCiudad": "15660",
        "nombre": "SAN EDUARDO - BOYACA",
        "ciuu": "15660",
        "departamento": ""
    },
    {
        "idCiudad": "13647",
        "nombre": "SAN ESTANISLAO - BOLIVAR",
        "ciuu": "13647",
        "departamento": ""
    },
    {
        "idCiudad": "94883",
        "nombre": "SAN FELIPE - GUAINIA",
        "ciuu": "94883",
        "departamento": ""
    },
    {
        "idCiudad": "13650",
        "nombre": "SAN FERNANDO - BOLIVAR",
        "ciuu": "13650",
        "departamento": ""
    },
    {
        "idCiudad": "05652",
        "nombre": "SAN FRANCISCO - ANTIOQUIA",
        "ciuu": "05652",
        "departamento": ""
    },
    {
        "idCiudad": "25658",
        "nombre": "SAN FRANCISCO - CUNDINAMARCA",
        "ciuu": "25658",
        "departamento": ""
    },
    {
        "idCiudad": "86755",
        "nombre": "SAN FRANCISCO - PUTUMAYO",
        "ciuu": "86755",
        "departamento": ""
    },
    {
        "idCiudad": "68679",
        "nombre": "SAN GIL - SANTANDER",
        "ciuu": "68679",
        "departamento": ""
    },
    {
        "idCiudad": "13654",
        "nombre": "SAN JACINTO - BOLIVAR",
        "ciuu": "13654",
        "departamento": ""
    },
    {
        "idCiudad": "13655",
        "nombre": "SAN JACINTO DEL CAUCA - BOLIVA",
        "ciuu": "13655",
        "departamento": ""
    },
    {
        "idCiudad": "05656",
        "nombre": "SAN JERONIMO - ANTIOQUIA",
        "ciuu": "05656",
        "departamento": ""
    },
    {
        "idCiudad": "68682",
        "nombre": "SAN JOAQUIN - SANTANDER",
        "ciuu": "68682",
        "departamento": ""
    },
    {
        "idCiudad": "17665",
        "nombre": "SAN JOSE - CALDAS",
        "ciuu": "17665",
        "departamento": ""
    },
    {
        "idCiudad": "05658",
        "nombre": "SAN JOSE DE LA MONTAÑA - ANTIO",
        "ciuu": "05658",
        "departamento": ""
    },
    {
        "idCiudad": "68684",
        "nombre": "SAN JOSE DE MIRANDA - SANTANDE",
        "ciuu": "68684",
        "departamento": ""
    },
    {
        "idCiudad": "15664",
        "nombre": "SAN JOSE DE PARE - BOYACA",
        "ciuu": "15664",
        "departamento": ""
    },
    {
        "idCiudad": "23682",
        "nombre": "SAN JOSE DE URE - CORDOBA",
        "ciuu": "23682",
        "departamento": ""
    },
    {
        "idCiudad": "18610",
        "nombre": "SAN JOSE DEL FRAGUA - CAQUETA",
        "ciuu": "18610",
        "departamento": ""
    },
    {
        "idCiudad": "95001",
        "nombre": "SAN JOSE DEL GUAVIARE - GUAVIA",
        "ciuu": "95001",
        "departamento": ""
    },
    {
        "idCiudad": "27660",
        "nombre": "SAN JOSE DEL PALMAR - CHOCO",
        "ciuu": "27660",
        "departamento": ""
    },
    {
        "idCiudad": "50683",
        "nombre": "SAN JUAN DE ARAMA - META",
        "ciuu": "50683",
        "departamento": ""
    },
    {
        "idCiudad": "70702",
        "nombre": "SAN JUAN DE BETULIA - SUCRE",
        "ciuu": "70702",
        "departamento": ""
    },
    {
        "idCiudad": "25662",
        "nombre": "SAN JUAN DE RIO SECO - CUNDINA",
        "ciuu": "25662",
        "departamento": ""
    },
    {
        "idCiudad": "05659",
        "nombre": "SAN JUAN DE URABA - ANTIOQUIA",
        "ciuu": "05659",
        "departamento": ""
    },
    {
        "idCiudad": "44650",
        "nombre": "SAN JUAN DEL CESAR - LA GUAJIR",
        "ciuu": "44650",
        "departamento": ""
    },
    {
        "idCiudad": "13657",
        "nombre": "SAN JUAN NEPOMUCENO - BOLIVAR",
        "ciuu": "13657",
        "departamento": ""
    },
    {
        "idCiudad": "50686",
        "nombre": "SAN JUANITO - META",
        "ciuu": "50686",
        "departamento": ""
    },
    {
        "idCiudad": "52687",
        "nombre": "SAN LORENZO - NARIÑO",
        "ciuu": "52687",
        "departamento": ""
    },
    {
        "idCiudad": "05660",
        "nombre": "SAN LUIS - ANTIOQUIA",
        "ciuu": "05660",
        "departamento": ""
    },
    {
        "idCiudad": "73678",
        "nombre": "SAN LUIS - TOLIMA",
        "ciuu": "73678",
        "departamento": ""
    },
    {
        "idCiudad": "15667",
        "nombre": "SAN LUIS DE GACENO - BOYACA",
        "ciuu": "15667",
        "departamento": ""
    },
    {
        "idCiudad": "85325",
        "nombre": "SAN LUIS DE PALENQUE - CASANAR",
        "ciuu": "85325",
        "departamento": ""
    },
    {
        "idCiudad": "70742",
        "nombre": "SAN LUIS DE SINCE - SUCRE",
        "ciuu": "70742",
        "departamento": ""
    },
    {
        "idCiudad": "70708",
        "nombre": "SAN MARCOS - SUCRE",
        "ciuu": "70708",
        "departamento": ""
    },
    {
        "idCiudad": "20770",
        "nombre": "SAN MARTIN - CESAR",
        "ciuu": "20770",
        "departamento": ""
    },
    {
        "idCiudad": "50689",
        "nombre": "SAN MARTIN - META",
        "ciuu": "50689",
        "departamento": ""
    },
    {
        "idCiudad": "13667",
        "nombre": "SAN MARTIN DE LOBA - BOLIVAR",
        "ciuu": "13667",
        "departamento": ""
    },
    {
        "idCiudad": "15673",
        "nombre": "SAN MATEO - BOYACA",
        "ciuu": "15673",
        "departamento": ""
    },
    {
        "idCiudad": "86757",
        "nombre": "SAN MIGUEL - PUTUMAYO",
        "ciuu": "86757",
        "departamento": ""
    },
    {
        "idCiudad": "68686",
        "nombre": "SAN MIGUEL - SANTANDER",
        "ciuu": "68686",
        "departamento": ""
    },
    {
        "idCiudad": "15676",
        "nombre": "SAN MIGUEL DE SEMA - BOYACA",
        "ciuu": "15676",
        "departamento": ""
    },
    {
        "idCiudad": "70713",
        "nombre": "SAN ONOFRE - SUCRE",
        "ciuu": "70713",
        "departamento": ""
    },
    {
        "idCiudad": "13670",
        "nombre": "SAN PABLO - BOLIVAR",
        "ciuu": "13670",
        "departamento": ""
    },
    {
        "idCiudad": "52693",
        "nombre": "SAN PABLO - NARIÑO",
        "ciuu": "52693",
        "departamento": ""
    },
    {
        "idCiudad": "15681",
        "nombre": "SAN PABLO DE BORBUR - BOYACA",
        "ciuu": "15681",
        "departamento": ""
    },
    {
        "idCiudad": "05664",
        "nombre": "SAN PEDRO - ANTIOQUIA",
        "ciuu": "05664",
        "departamento": ""
    },
    {
        "idCiudad": "70717",
        "nombre": "SAN PEDRO - SUCRE",
        "ciuu": "70717",
        "departamento": ""
    },
    {
        "idCiudad": "76670",
        "nombre": "SAN PEDRO - VALLE DEL CAUCA",
        "ciuu": "76670",
        "departamento": ""
    },
    {
        "idCiudad": "52694",
        "nombre": "SAN PEDRO DE CARTAGO - NARIÑO",
        "ciuu": "52694",
        "departamento": ""
    },
    {
        "idCiudad": "05665",
        "nombre": "SAN PEDRO DE URABA - ANTIOQUIA",
        "ciuu": "05665",
        "departamento": ""
    },
    {
        "idCiudad": "23686",
        "nombre": "SAN PELAYO - CORDOBA",
        "ciuu": "23686",
        "departamento": ""
    },
    {
        "idCiudad": "05667",
        "nombre": "SAN RAFAEL - ANTIOQUIA",
        "ciuu": "05667",
        "departamento": ""
    },
    {
        "idCiudad": "05670",
        "nombre": "SAN ROQUE - ANTIOQUIA",
        "ciuu": "05670",
        "departamento": ""
    },
    {
        "idCiudad": "19693",
        "nombre": "SAN SEBASTIAN - CAUCA",
        "ciuu": "19693",
        "departamento": ""
    },
    {
        "idCiudad": "47692",
        "nombre": "SAN SEBASTIAN DE BUENAVISTA -",
        "ciuu": "47692",
        "departamento": ""
    },
    {
        "idCiudad": "05674",
        "nombre": "SAN VICENTE - ANTIOQUIA",
        "ciuu": "05674",
        "departamento": ""
    },
    {
        "idCiudad": "68689",
        "nombre": "SAN VICENTE DE CHUCURI - SANTA",
        "ciuu": "68689",
        "departamento": ""
    },
    {
        "idCiudad": "18753",
        "nombre": "SAN VICENTE DEL CAGUAN - CAQUE",
        "ciuu": "18753",
        "departamento": ""
    },
    {
        "idCiudad": "47703",
        "nombre": "SAN ZENON - MAGDALENA",
        "ciuu": "47703",
        "departamento": ""
    },
    {
        "idCiudad": "52683",
        "nombre": "SANDONA - NARIÑO",
        "ciuu": "52683",
        "departamento": ""
    },
    {
        "idCiudad": "47707",
        "nombre": "SANTA ANA - MAGDALENA",
        "ciuu": "47707",
        "departamento": ""
    },
    {
        "idCiudad": "05679",
        "nombre": "SANTA BARBARA - ANTIOQUIA",
        "ciuu": "05679",
        "departamento": ""
    },
    {
        "idCiudad": "52696",
        "nombre": "SANTA BARBARA - NARIÑO",
        "ciuu": "52696",
        "departamento": ""
    },
    {
        "idCiudad": "68705",
        "nombre": "SANTA BARBARA - SANTANDER",
        "ciuu": "68705",
        "departamento": ""
    },
    {
        "idCiudad": "47720",
        "nombre": "SANTA BARBARA DE PINTO - MAGDA",
        "ciuu": "47720",
        "departamento": ""
    },
    {
        "idCiudad": "13673",
        "nombre": "SANTA CATALINA - BOLIVAR",
        "ciuu": "13673",
        "departamento": ""
    },
    {
        "idCiudad": "68720",
        "nombre": "SANTA HELENA DEL OPON - SANTAN",
        "ciuu": "68720",
        "departamento": ""
    },
    {
        "idCiudad": "73686",
        "nombre": "SANTA ISABEL - TOLIMA",
        "ciuu": "73686",
        "departamento": ""
    },
    {
        "idCiudad": "08675",
        "nombre": "SANTA LUCIA - ATLANTICO",
        "ciuu": "08675",
        "departamento": ""
    },
    {
        "idCiudad": "15690",
        "nombre": "SANTA MARIA - BOYACA",
        "ciuu": "15690",
        "departamento": ""
    },
    {
        "idCiudad": "41676",
        "nombre": "SANTA MARIA - HUILA",
        "ciuu": "41676",
        "departamento": ""
    },
    {
        "idCiudad": "47001",
        "nombre": "SANTA MARTA - MAGDALENA",
        "ciuu": "47001",
        "departamento": ""
    },
    {
        "idCiudad": "13683",
        "nombre": "SANTA ROSA - BOLIVAR",
        "ciuu": "13683",
        "departamento": ""
    },
    {
        "idCiudad": "19701",
        "nombre": "SANTA ROSA - CAUCA",
        "ciuu": "19701",
        "departamento": ""
    },
    {
        "idCiudad": "66682",
        "nombre": "SANTA ROSA DE CABAL - RISARALD",
        "ciuu": "66682",
        "departamento": ""
    },
    {
        "idCiudad": "05686",
        "nombre": "SANTA ROSA DE OSOS - ANTIOQUIA",
        "ciuu": "05686",
        "departamento": ""
    },
    {
        "idCiudad": "15693",
        "nombre": "SANTA ROSA DE VITERBO - BOYACA",
        "ciuu": "15693",
        "departamento": ""
    },
    {
        "idCiudad": "13688",
        "nombre": "SANTA ROSA DEL SUR - BOLIVAR",
        "ciuu": "13688",
        "departamento": ""
    },
    {
        "idCiudad": "99624",
        "nombre": "SANTA ROSALIA - VICHADA",
        "ciuu": "99624",
        "departamento": ""
    },
    {
        "idCiudad": "15696",
        "nombre": "SANTA SOFIA - BOYACA",
        "ciuu": "15696",
        "departamento": ""
    },
    {
        "idCiudad": "52699",
        "nombre": "SANTACRUZ - NARIÑO",
        "ciuu": "52699",
        "departamento": ""
    },
    {
        "idCiudad": "05042",
        "nombre": "SANTAFE DE ANTIOQUIA - ANTIOQU",
        "ciuu": "05042",
        "departamento": ""
    },
    {
        "idCiudad": "15686",
        "nombre": "SANTANA - BOYACA",
        "ciuu": "15686",
        "departamento": ""
    },
    {
        "idCiudad": "19698",
        "nombre": "SANTANDER DE QUILICHAO - CAUCA",
        "ciuu": "19698",
        "departamento": ""
    },
    {
        "idCiudad": "54680",
        "nombre": "SANTIAGO - N. DE SANTANDER",
        "ciuu": "54680",
        "departamento": ""
    },
    {
        "idCiudad": "86760",
        "nombre": "SANTIAGO - PUTUMAYO",
        "ciuu": "86760",
        "departamento": ""
    },
    {
        "idCiudad": "70820",
        "nombre": "SANTIAGO DE TOLU - SUCRE",
        "ciuu": "70820",
        "departamento": ""
    },
    {
        "idCiudad": "05690",
        "nombre": "SANTO DOMINGO - ANTIOQUIA",
        "ciuu": "05690",
        "departamento": ""
    },
    {
        "idCiudad": "08685",
        "nombre": "SANTO TOMAS - ATLANTICO",
        "ciuu": "08685",
        "departamento": ""
    },
    {
        "idCiudad": "66687",
        "nombre": "SANTUARIO - RISARALDA",
        "ciuu": "66687",
        "departamento": ""
    },
    {
        "idCiudad": "52720",
        "nombre": "SAPUYES - NARIÑO",
        "ciuu": "52720",
        "departamento": ""
    },
    {
        "idCiudad": "81736",
        "nombre": "SARAVENA - ARAUCA",
        "ciuu": "81736",
        "departamento": ""
    },
    {
        "idCiudad": "54720",
        "nombre": "SARDINATA - N. DE SANTANDER",
        "ciuu": "54720",
        "departamento": ""
    },
    {
        "idCiudad": "25718",
        "nombre": "SASAIMA - CUNDINAMARCA",
        "ciuu": "25718",
        "departamento": ""
    },
    {
        "idCiudad": "15720",
        "nombre": "SATIVANORTE - BOYACA",
        "ciuu": "15720",
        "departamento": ""
    },
    {
        "idCiudad": "15723",
        "nombre": "SATIVASUR - BOYACA",
        "ciuu": "15723",
        "departamento": ""
    },
    {
        "idCiudad": "05736",
        "nombre": "SEGOVIA - ANTIOQUIA",
        "ciuu": "05736",
        "departamento": ""
    },
    {
        "idCiudad": "25736",
        "nombre": "SESQUILE - CUNDINAMARCA",
        "ciuu": "25736",
        "departamento": ""
    },
    {
        "idCiudad": "76736",
        "nombre": "SEVILLA - VALLE DEL CAUCA",
        "ciuu": "76736",
        "departamento": ""
    },
    {
        "idCiudad": "15740",
        "nombre": "SIACHOQUE - BOYACA",
        "ciuu": "15740",
        "departamento": ""
    },
    {
        "idCiudad": "25740",
        "nombre": "SIBATE - CUNDINAMARCA",
        "ciuu": "25740",
        "departamento": ""
    },
    {
        "idCiudad": "86749",
        "nombre": "SIBUNDOY - PUTUMAYO",
        "ciuu": "86749",
        "departamento": ""
    },
    {
        "idCiudad": "54743",
        "nombre": "SILOS - N. DE SANTANDER",
        "ciuu": "54743",
        "departamento": ""
    },
    {
        "idCiudad": "25743",
        "nombre": "SILVANIA - CUNDINAMARCA",
        "ciuu": "25743",
        "departamento": ""
    },
    {
        "idCiudad": "19743",
        "nombre": "SILVIA - CAUCA",
        "ciuu": "19743",
        "departamento": ""
    },
    {
        "idCiudad": "68745",
        "nombre": "SIMACOTA - SANTANDER",
        "ciuu": "68745",
        "departamento": ""
    },
    {
        "idCiudad": "25745",
        "nombre": "SIMIJACA - CUNDINAMARCA",
        "ciuu": "25745",
        "departamento": ""
    },
    {
        "idCiudad": "13744",
        "nombre": "SIMITI - BOLIVAR",
        "ciuu": "13744",
        "departamento": ""
    },
    {
        "idCiudad": "70001",
        "nombre": "SINCELEJO - SUCRE",
        "ciuu": "70001",
        "departamento": ""
    },
    {
        "idCiudad": "27745",
        "nombre": "SIPI - CHOCO",
        "ciuu": "27745",
        "departamento": ""
    },
    {
        "idCiudad": "47745",
        "nombre": "SITIONUEVO - MAGDALENA",
        "ciuu": "47745",
        "departamento": ""
    },
    {
        "idCiudad": "25754",
        "nombre": "SOACHA - CUNDINAMARCA",
        "ciuu": "25754",
        "departamento": ""
    },
    {
        "idCiudad": "15753",
        "nombre": "SOATA - BOYACA",
        "ciuu": "15753",
        "departamento": ""
    },
    {
        "idCiudad": "15757",
        "nombre": "SOCHA - BOYACA",
        "ciuu": "15757",
        "departamento": ""
    },
    {
        "idCiudad": "68755",
        "nombre": "SOCORRO - SANTANDER",
        "ciuu": "68755",
        "departamento": ""
    },
    {
        "idCiudad": "15755",
        "nombre": "SOCOTA - BOYACA",
        "ciuu": "15755",
        "departamento": ""
    },
    {
        "idCiudad": "15759",
        "nombre": "SOGAMOSO - BOYACA",
        "ciuu": "15759",
        "departamento": ""
    },
    {
        "idCiudad": "18756",
        "nombre": "SOLANO - CAQUETA",
        "ciuu": "18756",
        "departamento": ""
    },
    {
        "idCiudad": "08758",
        "nombre": "SOLEDAD - ATLANTICO",
        "ciuu": "08758",
        "departamento": ""
    },
    {
        "idCiudad": "18785",
        "nombre": "SOLITA - CAQUETA",
        "ciuu": "18785",
        "departamento": ""
    },
    {
        "idCiudad": "15761",
        "nombre": "SOMONDOCO - BOYACA",
        "ciuu": "15761",
        "departamento": ""
    },
    {
        "idCiudad": "05756",
        "nombre": "SONSON - ANTIOQUIA",
        "ciuu": "05756",
        "departamento": ""
    },
    {
        "idCiudad": "05761",
        "nombre": "SOPETRAN - ANTIOQUIA",
        "ciuu": "05761",
        "departamento": ""
    },
    {
        "idCiudad": "13760",
        "nombre": "SOPLAVIENTO - BOLIVAR",
        "ciuu": "13760",
        "departamento": ""
    },
    {
        "idCiudad": "25758",
        "nombre": "SOPO - CUNDINAMARCA",
        "ciuu": "25758",
        "departamento": ""
    },
    {
        "idCiudad": "15762",
        "nombre": "SORA - BOYACA",
        "ciuu": "15762",
        "departamento": ""
    },
    {
        "idCiudad": "15764",
        "nombre": "SORACA - BOYACA",
        "ciuu": "15764",
        "departamento": ""
    },
    {
        "idCiudad": "15763",
        "nombre": "SOTAQUIRA - BOYACA",
        "ciuu": "15763",
        "departamento": ""
    },
    {
        "idCiudad": "19760",
        "nombre": "SOTARA - CAUCA",
        "ciuu": "19760",
        "departamento": ""
    },
    {
        "idCiudad": "68770",
        "nombre": "SUAITA - SANTANDER",
        "ciuu": "68770",
        "departamento": ""
    },
    {
        "idCiudad": "08770",
        "nombre": "SUAN - ATLANTICO",
        "ciuu": "08770",
        "departamento": ""
    },
    {
        "idCiudad": "19780",
        "nombre": "SUAREZ - CAUCA",
        "ciuu": "19780",
        "departamento": ""
    },
    {
        "idCiudad": "73770",
        "nombre": "SUAREZ - TOLIMA",
        "ciuu": "73770",
        "departamento": ""
    },
    {
        "idCiudad": "41770",
        "nombre": "SUAZA - HUILA",
        "ciuu": "41770",
        "departamento": ""
    },
    {
        "idCiudad": "25769",
        "nombre": "SUBACHOQUE - CUNDINAMARCA",
        "ciuu": "25769",
        "departamento": ""
    },
    {
        "idCiudad": "19785",
        "nombre": "SUCRE - CAUCA",
        "ciuu": "19785",
        "departamento": ""
    },
    {
        "idCiudad": "68773",
        "nombre": "SUCRE - SANTANDER",
        "ciuu": "68773",
        "departamento": ""
    },
    {
        "idCiudad": "70771",
        "nombre": "SUCRE - SUCRE",
        "ciuu": "70771",
        "departamento": ""
    },
    {
        "idCiudad": "25772",
        "nombre": "SUESCA - CUNDINAMARCA",
        "ciuu": "25772",
        "departamento": ""
    },
    {
        "idCiudad": "25777",
        "nombre": "SUPATA - CUNDINAMARCA",
        "ciuu": "25777",
        "departamento": ""
    },
    {
        "idCiudad": "17777",
        "nombre": "SUPIA - CALDAS",
        "ciuu": "17777",
        "departamento": ""
    },
    {
        "idCiudad": "68780",
        "nombre": "SURATA - SANTANDER",
        "ciuu": "68780",
        "departamento": ""
    },
    {
        "idCiudad": "25779",
        "nombre": "SUSA - CUNDINAMARCA",
        "ciuu": "25779",
        "departamento": ""
    },
    {
        "idCiudad": "15774",
        "nombre": "SUSACON - BOYACA",
        "ciuu": "15774",
        "departamento": ""
    },
    {
        "idCiudad": "15776",
        "nombre": "SUTAMARCHAN - BOYACA",
        "ciuu": "15776",
        "departamento": ""
    },
    {
        "idCiudad": "25781",
        "nombre": "SUTATAUSA - CUNDINAMARCA",
        "ciuu": "25781",
        "departamento": ""
    },
    {
        "idCiudad": "15778",
        "nombre": "SUTATENZA - BOYACA",
        "ciuu": "15778",
        "departamento": ""
    },
    {
        "idCiudad": "25785",
        "nombre": "TABIO - CUNDINAMARCA",
        "ciuu": "25785",
        "departamento": ""
    },
    {
        "idCiudad": "27787",
        "nombre": "TADO - CHOCO",
        "ciuu": "27787",
        "departamento": ""
    },
    {
        "idCiudad": "13780",
        "nombre": "TALAIGUA NUEVO - BOLIVAR",
        "ciuu": "13780",
        "departamento": ""
    },
    {
        "idCiudad": "20787",
        "nombre": "TAMALAMEQUE - CESAR",
        "ciuu": "20787",
        "departamento": ""
    },
    {
        "idCiudad": "85400",
        "nombre": "TAMARA - CASANARE",
        "ciuu": "85400",
        "departamento": ""
    },
    {
        "idCiudad": "81794",
        "nombre": "TAME - ARAUCA",
        "ciuu": "81794",
        "departamento": ""
    },
    {
        "idCiudad": "05789",
        "nombre": "TAMESIS - ANTIOQUIA",
        "ciuu": "05789",
        "departamento": ""
    },
    {
        "idCiudad": "52786",
        "nombre": "TAMINANGO - NARIÑO",
        "ciuu": "52786",
        "departamento": ""
    },
    {
        "idCiudad": "52788",
        "nombre": "TANGUA - NARIÑO",
        "ciuu": "52788",
        "departamento": ""
    },
    {
        "idCiudad": "97666",
        "nombre": "TARAIRA - VAUPES",
        "ciuu": "97666",
        "departamento": ""
    },
    {
        "idCiudad": "91798",
        "nombre": "TARAPACA - AMAZONAS",
        "ciuu": "91798",
        "departamento": ""
    },
    {
        "idCiudad": "05790",
        "nombre": "TARAZA - ANTIOQUIA",
        "ciuu": "05790",
        "departamento": ""
    },
    {
        "idCiudad": "41791",
        "nombre": "TARQUI - HUILA",
        "ciuu": "41791",
        "departamento": ""
    },
    {
        "idCiudad": "05792",
        "nombre": "TARSO - ANTIOQUIA",
        "ciuu": "05792",
        "departamento": ""
    },
    {
        "idCiudad": "15790",
        "nombre": "TASCO - BOYACA",
        "ciuu": "15790",
        "departamento": ""
    },
    {
        "idCiudad": "85410",
        "nombre": "TAURAMENA - CASANARE",
        "ciuu": "85410",
        "departamento": ""
    },
    {
        "idCiudad": "25793",
        "nombre": "TAUSA - CUNDINAMARCA",
        "ciuu": "25793",
        "departamento": ""
    },
    {
        "idCiudad": "41799",
        "nombre": "TELLO - HUILA",
        "ciuu": "41799",
        "departamento": ""
    },
    {
        "idCiudad": "25797",
        "nombre": "TENA - CUNDINAMARCA",
        "ciuu": "25797",
        "departamento": ""
    },
    {
        "idCiudad": "47798",
        "nombre": "TENERIFE - MAGDALENA",
        "ciuu": "47798",
        "departamento": ""
    },
    {
        "idCiudad": "25799",
        "nombre": "TENJO - CUNDINAMARCA",
        "ciuu": "25799",
        "departamento": ""
    },
    {
        "idCiudad": "15798",
        "nombre": "TENZA - BOYACA",
        "ciuu": "15798",
        "departamento": ""
    },
    {
        "idCiudad": "54800",
        "nombre": "TEORAMA - N. DE SANTANDER",
        "ciuu": "54800",
        "departamento": ""
    },
    {
        "idCiudad": "41801",
        "nombre": "TERUEL - HUILA",
        "ciuu": "41801",
        "departamento": ""
    },
    {
        "idCiudad": "41797",
        "nombre": "TESALIA - HUILA",
        "ciuu": "41797",
        "departamento": ""
    },
    {
        "idCiudad": "25805",
        "nombre": "TIBACUY - CUNDINAMARCA",
        "ciuu": "25805",
        "departamento": ""
    },
    {
        "idCiudad": "15804",
        "nombre": "TIBANA - BOYACA",
        "ciuu": "15804",
        "departamento": ""
    },
    {
        "idCiudad": "15806",
        "nombre": "TIBASOSA - BOYACA",
        "ciuu": "15806",
        "departamento": ""
    },
    {
        "idCiudad": "25807",
        "nombre": "TIBIRITA - CUNDINAMARCA",
        "ciuu": "25807",
        "departamento": ""
    },
    {
        "idCiudad": "54810",
        "nombre": "TIBU - N. DE SANTANDER",
        "ciuu": "54810",
        "departamento": ""
    },
    {
        "idCiudad": "23807",
        "nombre": "TIERRALTA - CORDOBA",
        "ciuu": "23807",
        "departamento": ""
    },
    {
        "idCiudad": "41807",
        "nombre": "TIMANA - HUILA",
        "ciuu": "41807",
        "departamento": ""
    },
    {
        "idCiudad": "19807",
        "nombre": "TIMBIO - CAUCA",
        "ciuu": "19807",
        "departamento": ""
    },
    {
        "idCiudad": "19809",
        "nombre": "TIMBIQUI - CAUCA",
        "ciuu": "19809",
        "departamento": ""
    },
    {
        "idCiudad": "15808",
        "nombre": "TINJACA - BOYACA",
        "ciuu": "15808",
        "departamento": ""
    },
    {
        "idCiudad": "15810",
        "nombre": "TIPACOQUE - BOYACA",
        "ciuu": "15810",
        "departamento": ""
    },
    {
        "idCiudad": "13810",
        "nombre": "TIQUISIO - BOLIVAR",
        "ciuu": "13810",
        "departamento": ""
    },
    {
        "idCiudad": "05809",
        "nombre": "TITIRIBI - ANTIOQUIA",
        "ciuu": "05809",
        "departamento": ""
    },
    {
        "idCiudad": "15814",
        "nombre": "TOCA - BOYACA",
        "ciuu": "15814",
        "departamento": ""
    },
    {
        "idCiudad": "25815",
        "nombre": "TOCAIMA - CUNDINAMARCA",
        "ciuu": "25815",
        "departamento": ""
    },
    {
        "idCiudad": "25817",
        "nombre": "TOCANCIPA - CUNDINAMARCA",
        "ciuu": "25817",
        "departamento": ""
    },
    {
        "idCiudad": "15816",
        "nombre": "TOGsI - BOYACA",
        "ciuu": "15816",
        "departamento": ""
    },
    {
        "idCiudad": "05819",
        "nombre": "TOLEDO - ANTIOQUIA",
        "ciuu": "05819",
        "departamento": ""
    },
    {
        "idCiudad": "54820",
        "nombre": "TOLEDO - N. DE SANTANDER",
        "ciuu": "54820",
        "departamento": ""
    },
    {
        "idCiudad": "70823",
        "nombre": "TOLU VIEJO - SUCRE",
        "ciuu": "70823",
        "departamento": ""
    },
    {
        "idCiudad": "68820",
        "nombre": "TONA - SANTANDER",
        "ciuu": "68820",
        "departamento": ""
    },
    {
        "idCiudad": "15820",
        "nombre": "TOPAGA - BOYACA",
        "ciuu": "15820",
        "departamento": ""
    },
    {
        "idCiudad": "25823",
        "nombre": "TOPAIPI - CUNDINAMARCA",
        "ciuu": "25823",
        "departamento": ""
    },
    {
        "idCiudad": "19821",
        "nombre": "TORIBIO - CAUCA",
        "ciuu": "19821",
        "departamento": ""
    },
    {
        "idCiudad": "76823",
        "nombre": "TORO - VALLE DEL CAUCA",
        "ciuu": "76823",
        "departamento": ""
    },
    {
        "idCiudad": "15822",
        "nombre": "TOTA - BOYACA",
        "ciuu": "15822",
        "departamento": ""
    },
    {
        "idCiudad": "19824",
        "nombre": "TOTORO - CAUCA",
        "ciuu": "19824",
        "departamento": ""
    },
    {
        "idCiudad": "85430",
        "nombre": "TRINIDAD - CASANARE",
        "ciuu": "85430",
        "departamento": ""
    },
    {
        "idCiudad": "76828",
        "nombre": "TRUJILLO - VALLE DEL CAUCA",
        "ciuu": "76828",
        "departamento": ""
    },
    {
        "idCiudad": "08832",
        "nombre": "TUBARA - ATLANTICO",
        "ciuu": "08832",
        "departamento": ""
    },
    {
        "idCiudad": "23815",
        "nombre": "TUCHIN - CORDOBA",
        "ciuu": "23815",
        "departamento": ""
    },
    {
        "idCiudad": "76834",
        "nombre": "TULUA - VALLE DEL CAUCA",
        "ciuu": "76834",
        "departamento": ""
    },
    {
        "idCiudad": "15001",
        "nombre": "TUNJA - BOYACA",
        "ciuu": "15001",
        "departamento": ""
    },
    {
        "idCiudad": "15832",
        "nombre": "TUNUNGUA - BOYACA",
        "ciuu": "15832",
        "departamento": ""
    },
    {
        "idCiudad": "52838",
        "nombre": "TUQUERRES - NARIÑO",
        "ciuu": "52838",
        "departamento": ""
    },
    {
        "idCiudad": "13836",
        "nombre": "TURBACO - BOLIVAR",
        "ciuu": "13836",
        "departamento": ""
    },
    {
        "idCiudad": "13838",
        "nombre": "TURBANA - BOLIVAR",
        "ciuu": "13838",
        "departamento": ""
    },
    {
        "idCiudad": "05837",
        "nombre": "TURBO - ANTIOQUIA",
        "ciuu": "05837",
        "departamento": ""
    },
    {
        "idCiudad": "15835",
        "nombre": "TURMEQUE - BOYACA",
        "ciuu": "15835",
        "departamento": ""
    },
    {
        "idCiudad": "15837",
        "nombre": "TUTA - BOYACA",
        "ciuu": "15837",
        "departamento": ""
    },
    {
        "idCiudad": "15839",
        "nombre": "TUTAZA - BOYACA",
        "ciuu": "15839",
        "departamento": ""
    },
    {
        "idCiudad": "25839",
        "nombre": "UBALA - CUNDINAMARCA",
        "ciuu": "25839",
        "departamento": ""
    },
    {
        "idCiudad": "25841",
        "nombre": "UBAQUE - CUNDINAMARCA",
        "ciuu": "25841",
        "departamento": ""
    },
    {
        "idCiudad": "76845",
        "nombre": "ULLOA - VALLE DEL CAUCA",
        "ciuu": "76845",
        "departamento": ""
    },
    {
        "idCiudad": "15842",
        "nombre": "UMBITA - BOYACA",
        "ciuu": "15842",
        "departamento": ""
    },
    {
        "idCiudad": "25845",
        "nombre": "UNE - CUNDINAMARCA",
        "ciuu": "25845",
        "departamento": ""
    },
    {
        "idCiudad": "27800",
        "nombre": "UNGUIA - CHOCO",
        "ciuu": "27800",
        "departamento": ""
    },
    {
        "idCiudad": "27810",
        "nombre": "UNION PANAMERICANA - CHOCO",
        "ciuu": "27810",
        "departamento": ""
    },
    {
        "idCiudad": "05842",
        "nombre": "URAMITA - ANTIOQUIA",
        "ciuu": "05842",
        "departamento": ""
    },
    {
        "idCiudad": "50370",
        "nombre": "URIBE - META",
        "ciuu": "50370",
        "departamento": ""
    },
    {
        "idCiudad": "44847",
        "nombre": "URIBIA - LA GUAJIRA",
        "ciuu": "44847",
        "departamento": ""
    },
    {
        "idCiudad": "05847",
        "nombre": "URRAO - ANTIOQUIA",
        "ciuu": "05847",
        "departamento": ""
    },
    {
        "idCiudad": "44855",
        "nombre": "URUMITA - LA GUAJIRA",
        "ciuu": "44855",
        "departamento": ""
    },
    {
        "idCiudad": "08849",
        "nombre": "USIACURI - ATLANTICO",
        "ciuu": "08849",
        "departamento": ""
    },
    {
        "idCiudad": "25851",
        "nombre": "UTICA - CUNDINAMARCA",
        "ciuu": "25851",
        "departamento": ""
    },
    {
        "idCiudad": "05854",
        "nombre": "VALDIVIA - ANTIOQUIA",
        "ciuu": "05854",
        "departamento": ""
    },
    {
        "idCiudad": "23855",
        "nombre": "VALENCIA - CORDOBA",
        "ciuu": "23855",
        "departamento": ""
    },
    {
        "idCiudad": "68855",
        "nombre": "VALLE DE SAN JOSE - SANTANDER",
        "ciuu": "68855",
        "departamento": ""
    },
    {
        "idCiudad": "73854",
        "nombre": "VALLE DE SAN JUAN - TOLIMA",
        "ciuu": "73854",
        "departamento": ""
    },
    {
        "idCiudad": "86865",
        "nombre": "VALLE DEL GUAMUEZ - PUTUMAYO",
        "ciuu": "86865",
        "departamento": ""
    },
    {
        "idCiudad": "20001",
        "nombre": "VALLEDUPAR - CESAR",
        "ciuu": "20001",
        "departamento": ""
    },
    {
        "idCiudad": "05856",
        "nombre": "VALPARAISO - ANTIOQUIA",
        "ciuu": "05856",
        "departamento": ""
    },
    {
        "idCiudad": "18860",
        "nombre": "VALPARAISO - CAQUETA",
        "ciuu": "18860",
        "departamento": ""
    },
    {
        "idCiudad": "05858",
        "nombre": "VEGACHI - ANTIOQUIA",
        "ciuu": "05858",
        "departamento": ""
    },
    {
        "idCiudad": "68861",
        "nombre": "VELEZ - SANTANDER",
        "ciuu": "68861",
        "departamento": ""
    },
    {
        "idCiudad": "73861",
        "nombre": "VENADILLO - TOLIMA",
        "ciuu": "73861",
        "departamento": ""
    },
    {
        "idCiudad": "05861",
        "nombre": "VENECIA - ANTIOQUIA",
        "ciuu": "05861",
        "departamento": ""
    },
    {
        "idCiudad": "25506",
        "nombre": "VENECIA - CUNDINAMARCA",
        "ciuu": "25506",
        "departamento": ""
    },
    {
        "idCiudad": "15861",
        "nombre": "VENTAQUEMADA - BOYACA",
        "ciuu": "15861",
        "departamento": ""
    },
    {
        "idCiudad": "25862",
        "nombre": "VERGARA - CUNDINAMARCA",
        "ciuu": "25862",
        "departamento": ""
    },
    {
        "idCiudad": "76863",
        "nombre": "VERSALLES - VALLE DEL CAUCA",
        "ciuu": "76863",
        "departamento": ""
    },
    {
        "idCiudad": "68867",
        "nombre": "VETAS - SANTANDER",
        "ciuu": "68867",
        "departamento": ""
    },
    {
        "idCiudad": "25867",
        "nombre": "VIANI - CUNDINAMARCA",
        "ciuu": "25867",
        "departamento": ""
    },
    {
        "idCiudad": "17867",
        "nombre": "VICTORIA - CALDAS",
        "ciuu": "17867",
        "departamento": ""
    },
    {
        "idCiudad": "05873",
        "nombre": "VIGIA DEL FUERTE - ANTIOQUIA",
        "ciuu": "05873",
        "departamento": ""
    },
    {
        "idCiudad": "76869",
        "nombre": "VIJES - VALLE DEL CAUCA",
        "ciuu": "76869",
        "departamento": ""
    },
    {
        "idCiudad": "54871",
        "nombre": "VILLA CARO - N. DE SANTANDER",
        "ciuu": "54871",
        "departamento": ""
    },
    {
        "idCiudad": "15407",
        "nombre": "VILLA DE LEYVA - BOYACA",
        "ciuu": "15407",
        "departamento": ""
    },
    {
        "idCiudad": "25843",
        "nombre": "VILLA DE SAN DIEGO DE UBATE -",
        "ciuu": "25843",
        "departamento": ""
    },
    {
        "idCiudad": "54874",
        "nombre": "VILLA DEL ROSARIO - N. DE SANT",
        "ciuu": "54874",
        "departamento": ""
    },
    {
        "idCiudad": "19845",
        "nombre": "VILLA RICA - CAUCA",
        "ciuu": "19845",
        "departamento": ""
    },
    {
        "idCiudad": "86885",
        "nombre": "VILLAGARZON - PUTUMAYO",
        "ciuu": "86885",
        "departamento": ""
    },
    {
        "idCiudad": "25871",
        "nombre": "VILLAGOMEZ - CUNDINAMARCA",
        "ciuu": "25871",
        "departamento": ""
    },
    {
        "idCiudad": "73870",
        "nombre": "VILLAHERMOSA - TOLIMA",
        "ciuu": "73870",
        "departamento": ""
    },
    {
        "idCiudad": "17873",
        "nombre": "VILLAMARIA - CALDAS",
        "ciuu": "17873",
        "departamento": ""
    },
    {
        "idCiudad": "13873",
        "nombre": "VILLANUEVA - BOLIVAR",
        "ciuu": "13873",
        "departamento": ""
    },
    {
        "idCiudad": "85440",
        "nombre": "VILLANUEVA - CASANARE",
        "ciuu": "85440",
        "departamento": ""
    },
    {
        "idCiudad": "44874",
        "nombre": "VILLANUEVA - LA GUAJIRA",
        "ciuu": "44874",
        "departamento": ""
    },
    {
        "idCiudad": "68872",
        "nombre": "VILLANUEVA - SANTANDER",
        "ciuu": "68872",
        "departamento": ""
    },
    {
        "idCiudad": "25873",
        "nombre": "VILLAPINZON - CUNDINAMARCA",
        "ciuu": "25873",
        "departamento": ""
    },
    {
        "idCiudad": "73873",
        "nombre": "VILLARRICA - TOLIMA",
        "ciuu": "73873",
        "departamento": ""
    },
    {
        "idCiudad": "50001",
        "nombre": "VILLAVICENCIO - META",
        "ciuu": "50001",
        "departamento": ""
    },
    {
        "idCiudad": "41872",
        "nombre": "VILLAVIEJA - HUILA",
        "ciuu": "41872",
        "departamento": ""
    },
    {
        "idCiudad": "25875",
        "nombre": "VILLETA - CUNDINAMARCA",
        "ciuu": "25875",
        "departamento": ""
    },
    {
        "idCiudad": "25878",
        "nombre": "VIOTA - CUNDINAMARCA",
        "ciuu": "25878",
        "departamento": ""
    },
    {
        "idCiudad": "15879",
        "nombre": "VIRACACHA - BOYACA",
        "ciuu": "15879",
        "departamento": ""
    },
    {
        "idCiudad": "50711",
        "nombre": "VISTAHERMOSA - META",
        "ciuu": "50711",
        "departamento": ""
    },
    {
        "idCiudad": "17877",
        "nombre": "VITERBO - CALDAS",
        "ciuu": "17877",
        "departamento": ""
    },
    {
        "idCiudad": "25885",
        "nombre": "YACOPI - CUNDINAMARCA",
        "ciuu": "25885",
        "departamento": ""
    },
    {
        "idCiudad": "52885",
        "nombre": "YACUANQUER - NARIÑO",
        "ciuu": "52885",
        "departamento": ""
    },
    {
        "idCiudad": "41885",
        "nombre": "YAGUARA - HUILA",
        "ciuu": "41885",
        "departamento": ""
    },
    {
        "idCiudad": "05885",
        "nombre": "YALI - ANTIOQUIA",
        "ciuu": "05885",
        "departamento": ""
    },
    {
        "idCiudad": "05887",
        "nombre": "YARUMAL - ANTIOQUIA",
        "ciuu": "05887",
        "departamento": ""
    },
    {
        "idCiudad": "97889",
        "nombre": "YAVARATE - VAUPES",
        "ciuu": "97889",
        "departamento": ""
    },
    {
        "idCiudad": "05890",
        "nombre": "YOLOMBO - ANTIOQUIA",
        "ciuu": "05890",
        "departamento": ""
    },
    {
        "idCiudad": "05893",
        "nombre": "YONDO - ANTIOQUIA",
        "ciuu": "05893",
        "departamento": ""
    },
    {
        "idCiudad": "85001",
        "nombre": "YOPAL - CASANARE",
        "ciuu": "85001",
        "departamento": ""
    },
    {
        "idCiudad": "76890",
        "nombre": "YOTOCO - VALLE DEL CAUCA",
        "ciuu": "76890",
        "departamento": ""
    },
    {
        "idCiudad": "76892",
        "nombre": "YUMBO - VALLE DEL CAUCA",
        "ciuu": "76892",
        "departamento": ""
    },
    {
        "idCiudad": "13894",
        "nombre": "ZAMBRANO - BOLIVAR",
        "ciuu": "13894",
        "departamento": ""
    },
    {
        "idCiudad": "68895",
        "nombre": "ZAPATOCA - SANTANDER",
        "ciuu": "68895",
        "departamento": ""
    },
    {
        "idCiudad": "47960",
        "nombre": "ZAPAYAN - MAGDALENA",
        "ciuu": "47960",
        "departamento": ""
    },
    {
        "idCiudad": "05895",
        "nombre": "ZARAGOZA - ANTIOQUIA",
        "ciuu": "05895",
        "departamento": ""
    },
    {
        "idCiudad": "76895",
        "nombre": "ZARZAL - VALLE DEL CAUCA",
        "ciuu": "76895",
        "departamento": ""
    },
    {
        "idCiudad": "15897",
        "nombre": "ZETAQUIRA - BOYACA",
        "ciuu": "15897",
        "departamento": ""
    },
    {
        "idCiudad": "25898",
        "nombre": "ZIPACON - CUNDINAMARCA",
        "ciuu": "25898",
        "departamento": ""
    },
    {
        "idCiudad": "25899",
        "nombre": "ZIPAQUIRA - CUNDINAMARCA",
        "ciuu": "25899",
        "departamento": ""
    },
    {
        "idCiudad": "47980",
        "nombre": "ZONA BANANERA - MAGDALENA",
        "ciuu": "47980",
        "departamento": ""
    }
]
}